import { baseApi as api } from './base-api'
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAdOverviewAds: build.query<GetAdOverviewAdsApiResponse, GetAdOverviewAdsApiArg>({
      query: (queryArg) => ({
        url: '/ad-overview/ads',
        params: {
          project_id: queryArg.projectId,
          country_id: queryArg.countryId,
          site_id: queryArg.siteId,
          site: queryArg.site,
          search: queryArg.search,
          engine_id: queryArg.engineId,
          city_id: queryArg.cityId,
          browser_id: queryArg.browserId,
          os_id: queryArg.osId,
          is_decloak: queryArg.isDecloak,
          group: queryArg.group,
          is_shopping_ads: queryArg.isShoppingAds,
          is_top: queryArg.isTop,
          policy: queryArg.policy,
          advertiser_name: queryArg.advertiserName,
          advertiser_id: queryArg.advertiserId,
          affiliate: queryArg.affiliate,
          affiliate_id: queryArg.affiliateId,
          reversed_filters: queryArg.reversedFilters,
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          sort: queryArg.sort,
          export: queryArg['export'],
          exportColumns: queryArg.exportColumns,
          date: queryArg.date,
        },
      }),
    }),
    getAdOverviewAffiliates: build.query<
      GetAdOverviewAffiliatesApiResponse,
      GetAdOverviewAffiliatesApiArg
    >({
      query: (queryArg) => ({
        url: '/ad-overview/affiliates',
        params: {
          project_id: queryArg.projectId,
          country_id: queryArg.countryId,
          site_id: queryArg.siteId,
          site: queryArg.site,
          search: queryArg.search,
          engine_id: queryArg.engineId,
          city_id: queryArg.cityId,
          browser_id: queryArg.browserId,
          os_id: queryArg.osId,
          is_hidden: queryArg.isHidden,
          affiliate: queryArg.affiliate,
          policy: queryArg.policy,
          reversed_filters: queryArg.reversedFilters,
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          sort: queryArg.sort,
          export: queryArg['export'],
          exportColumns: queryArg.exportColumns,
          date: queryArg.date,
        },
      }),
    }),
    getAdOverviewAffiliatesAds: build.query<
      GetAdOverviewAffiliatesAdsApiResponse,
      GetAdOverviewAffiliatesAdsApiArg
    >({
      query: (queryArg) => ({
        url: '/ad-overview/affiliates-ads',
        params: {
          publisher_id: queryArg.publisherId,
          project_id: queryArg.projectId,
          country_id: queryArg.countryId,
          site_id: queryArg.siteId,
          site: queryArg.site,
          search: queryArg.search,
          engine_id: queryArg.engineId,
          city_id: queryArg.cityId,
          browser_id: queryArg.browserId,
          os_id: queryArg.osId,
          is_top: queryArg.isTop,
          policy: queryArg.policy,
          reversed_filters: queryArg.reversedFilters,
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          sort: queryArg.sort,
          export: queryArg['export'],
          exportColumns: queryArg.exportColumns,
          date: queryArg.date,
        },
      }),
    }),
    getAdOverviewPublisher: build.query<
      GetAdOverviewPublisherApiResponse,
      GetAdOverviewPublisherApiArg
    >({
      query: (queryArg) => ({
        url: '/ad-overview/publisher',
        params: {
          id: queryArg.id,
        },
      }),
    }),
    postAdOverviewPublisher: build.mutation<
      PostAdOverviewPublisherApiResponse,
      PostAdOverviewPublisherApiArg
    >({
      query: (queryArg) => ({ url: '/ad-overview/publisher', method: 'POST', body: queryArg.body }),
    }),
    postAdOverviewHideAffiliate: build.mutation<
      PostAdOverviewHideAffiliateApiResponse,
      PostAdOverviewHideAffiliateApiArg
    >({
      query: (queryArg) => ({
        url: '/ad-overview/hide-affiliate',
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getAdminVirtualUsers: build.query<GetAdminVirtualUsersApiResponse, GetAdminVirtualUsersApiArg>({
      query: () => ({ url: '/admin/virtual-users' }),
    }),
    postAdminVirtualLogin: build.mutation<
      PostAdminVirtualLoginApiResponse,
      PostAdminVirtualLoginApiArg
    >({
      query: (queryArg) => ({
        url: '/admin/virtual-login',
        method: 'POST',
        params: {
          user_id: queryArg.userId,
        },
      }),
    }),
    getAdvertiserReportsAllAdvertisers: build.query<
      GetAdvertiserReportsAllAdvertisersApiResponse,
      GetAdvertiserReportsAllAdvertisersApiArg
    >({
      query: (queryArg) => ({
        url: '/advertiser-reports/all-advertisers',
        params: {
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          sort: queryArg.sort,
          export: queryArg['export'],
          exportColumns: queryArg.exportColumns,
          date: queryArg.date,
          project_id: queryArg.projectId,
          policy: queryArg.policy,
          country_id: queryArg.countryId,
          site: queryArg.site,
          affiliate: queryArg.affiliate,
          affiliate_id: queryArg.affiliateId,
          browser_id: queryArg.browserId,
          device_id: queryArg.deviceId,
          engine_id: queryArg.engineId,
          keyword: queryArg.keyword,
          keyword_id: queryArg.keywordId,
          show_hidden: queryArg.showHidden,
          status: queryArg.status,
          show_affiliates: queryArg.showAffiliates,
          show_shopping_ads: queryArg.showShoppingAds,
          is_decloak: queryArg.isDecloak,
          is_top: queryArg.isTop,
          tag_ids: queryArg.tagIds,
          advertiser_name: queryArg.advertiserName,
          advertiser_id: queryArg.advertiserId,
          reversed_filters: queryArg.reversedFilters,
        },
      }),
    }),
    getAdvertiserReportsOrganic: build.query<
      GetAdvertiserReportsOrganicApiResponse,
      GetAdvertiserReportsOrganicApiArg
    >({
      query: (queryArg) => ({
        url: '/advertiser-reports/organic',
        params: {
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          sort: queryArg.sort,
          export: queryArg['export'],
          exportColumns: queryArg.exportColumns,
          date: queryArg.date,
          project_id: queryArg.projectId,
          country_id: queryArg.countryId,
          engine_id: queryArg.engineId,
          site: queryArg.site,
          policy: queryArg.policy,
          keyword: queryArg.keyword,
          keyword_id: queryArg.keywordId,
          affiliate: queryArg.affiliate,
          affiliate_id: queryArg.affiliateId,
          show_affiliates: queryArg.showAffiliates,
          show_hidden: queryArg.showHidden,
          tag_ids: queryArg.tagIds,
          has_brand: queryArg.hasBrand,
          reversed_filters: queryArg.reversedFilters,
        },
      }),
    }),
    postAdvertiserReportsSiteSettings: build.mutation<
      PostAdvertiserReportsSiteSettingsApiResponse,
      PostAdvertiserReportsSiteSettingsApiArg
    >({
      query: (queryArg) => ({
        url: '/advertiser-reports/site-settings',
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    postAdvertiserReportsDecloakSettings: build.mutation<
      PostAdvertiserReportsDecloakSettingsApiResponse,
      PostAdvertiserReportsDecloakSettingsApiArg
    >({
      query: (queryArg) => ({
        url: '/advertiser-reports/decloak-settings',
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getAffiliateGet: build.query<GetAffiliateGetApiResponse, GetAffiliateGetApiArg>({
      query: (queryArg) => ({
        url: '/affiliate/get',
        params: {
          id: queryArg.id,
          project_id: queryArg.projectId,
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          sort: queryArg.sort,
          date: queryArg.date,
        },
      }),
    }),
    getAffiliateLastAd: build.query<GetAffiliateLastAdApiResponse, GetAffiliateLastAdApiArg>({
      query: (queryArg) => ({
        url: '/affiliate/last-ad',
        params: {
          id: queryArg.id,
          project_id: queryArg.projectId,
          country_id: queryArg.countryId,
          engine_id: queryArg.engineId,
          city_id: queryArg.cityId,
          browser_id: queryArg.browserId,
          os_id: queryArg.osId,
          site: queryArg.site,
          keyword: queryArg.keyword,
          advertiser_name: queryArg.advertiserName,
          advertiser_id: queryArg.advertiserId,
          reversed_filters: queryArg.reversedFilters,
          date: queryArg.date,
          is_hijack: queryArg.isHijack,
          show_shopping_ads: queryArg.showShoppingAds,
          is_top: queryArg.isTop,
          affiliate: queryArg.affiliate,
          link_hash: queryArg.linkHash,
        },
      }),
    }),
    postAffiliateHide: build.mutation<PostAffiliateHideApiResponse, PostAffiliateHideApiArg>({
      query: (queryArg) => ({ url: '/affiliate/hide', method: 'POST', body: queryArg.body }),
    }),
    postAffiliateUpdate: build.mutation<PostAffiliateUpdateApiResponse, PostAffiliateUpdateApiArg>({
      query: (queryArg) => ({ url: '/affiliate/update', method: 'POST', body: queryArg.body }),
    }),
    postAffiliateCreateNetwork: build.mutation<
      PostAffiliateCreateNetworkApiResponse,
      PostAffiliateCreateNetworkApiArg
    >({
      query: (queryArg) => ({
        url: '/affiliate/create-network',
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getAffiliateRuleList: build.query<GetAffiliateRuleListApiResponse, GetAffiliateRuleListApiArg>({
      query: (queryArg) => ({
        url: '/affiliate-rule/list',
        params: {
          project_id: queryArg.projectId,
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          sort: queryArg.sort,
        },
      }),
    }),
    postAffiliateRuleCreate: build.mutation<
      PostAffiliateRuleCreateApiResponse,
      PostAffiliateRuleCreateApiArg
    >({
      query: (queryArg) => ({ url: '/affiliate-rule/create', method: 'POST', body: queryArg.body }),
    }),
    postAffiliateRuleUpdate: build.mutation<
      PostAffiliateRuleUpdateApiResponse,
      PostAffiliateRuleUpdateApiArg
    >({
      query: (queryArg) => ({ url: '/affiliate-rule/update', method: 'POST', body: queryArg.body }),
    }),
    postAffiliateRuleRunSync: build.mutation<
      PostAffiliateRuleRunSyncApiResponse,
      PostAffiliateRuleRunSyncApiArg
    >({
      query: (queryArg) => ({
        url: '/affiliate-rule/run-sync',
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    postAffiliateRuleDeleteAffiliates: build.mutation<
      PostAffiliateRuleDeleteAffiliatesApiResponse,
      PostAffiliateRuleDeleteAffiliatesApiArg
    >({
      query: (queryArg) => ({
        url: '/affiliate-rule/delete-affiliates',
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    postAffiliateRuleCreateCustomZone: build.mutation<
      PostAffiliateRuleCreateCustomZoneApiResponse,
      PostAffiliateRuleCreateCustomZoneApiArg
    >({
      query: (queryArg) => ({
        url: '/affiliate-rule/create-custom-zone',
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getComplianceNonCompliantAffiliates: build.query<
      GetComplianceNonCompliantAffiliatesApiResponse,
      GetComplianceNonCompliantAffiliatesApiArg
    >({
      query: (queryArg) => ({
        url: '/compliance/non-compliant-affiliates',
        params: {
          project_id: queryArg.projectId,
          country_id: queryArg.countryId,
          site: queryArg.site,
          engine_id: queryArg.engineId,
          city_id: queryArg.cityId,
          browser_id: queryArg.browserId,
          os_id: queryArg.osId,
          is_hidden: queryArg.isHidden,
          show_shopping_ads: queryArg.showShoppingAds,
          is_hijack: queryArg.isHijack,
          status_id: queryArg.statusId,
          affiliate_rule_id: queryArg.affiliateRuleId,
          status: queryArg.status,
          network: queryArg.network,
          network_id: queryArg.networkId,
          advertiser_name: queryArg.advertiserName,
          advertiser_id: queryArg.advertiserId,
          affiliate: queryArg.affiliate,
          affiliate_id: queryArg.affiliateId,
          aff_ids: queryArg.affIds,
          keyword: queryArg.keyword,
          reversed_filters: queryArg.reversedFilters,
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          sort: queryArg.sort,
          export: queryArg['export'],
          exportColumns: queryArg.exportColumns,
          date: queryArg.date,
        },
      }),
    }),
    postComplianceSendAbuseMail: build.mutation<
      PostComplianceSendAbuseMailApiResponse,
      PostComplianceSendAbuseMailApiArg
    >({
      query: (queryArg) => ({
        url: '/compliance/send-abuse-mail',
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getComplianceGetEmailList: build.query<
      GetComplianceGetEmailListApiResponse,
      GetComplianceGetEmailListApiArg
    >({
      query: () => ({ url: '/compliance/get-email-list' }),
    }),
    getComplianceLastSendEmail: build.query<
      GetComplianceLastSendEmailApiResponse,
      GetComplianceLastSendEmailApiArg
    >({
      query: (queryArg) => ({
        url: '/compliance/last-send-email',
        params: {
          project_id: queryArg.projectId,
          affiliate_id: queryArg.affiliateId,
          network_id: queryArg.networkId,
        },
      }),
    }),
    getDecloakFilter: build.query<GetDecloakFilterApiResponse, GetDecloakFilterApiArg>({
      query: (queryArg) => ({
        url: '/decloak/filter',
        params: {
          domain: queryArg.domain,
          country_id: queryArg.countryId,
          date: queryArg.date,
        },
      }),
    }),
    getDecloakCompareScreenshots: build.query<
      GetDecloakCompareScreenshotsApiResponse,
      GetDecloakCompareScreenshotsApiArg
    >({
      query: (queryArg) => ({
        url: '/decloak/compare-screenshots',
        params: {
          id: queryArg.id,
        },
      }),
    }),
    getDecloakCompareHtml: build.query<
      GetDecloakCompareHtmlApiResponse,
      GetDecloakCompareHtmlApiArg
    >({
      query: (queryArg) => ({
        url: '/decloak/compare-html',
        params: {
          id: queryArg.id,
        },
      }),
    }),
    getDecloakCompareLinks: build.query<
      GetDecloakCompareLinksApiResponse,
      GetDecloakCompareLinksApiArg
    >({
      query: (queryArg) => ({
        url: '/decloak/compare-links',
        params: {
          id: queryArg.id,
        },
      }),
    }),
    getDecloakAd: build.query<GetDecloakAdApiResponse, GetDecloakAdApiArg>({
      query: (queryArg) => ({
        url: '/decloak/ad',
        params: {
          id: queryArg.id,
        },
      }),
    }),
    getDecloakLive: build.query<GetDecloakLiveApiResponse, GetDecloakLiveApiArg>({
      query: (queryArg) => ({
        url: '/decloak/live',
        params: {
          deviceId: queryArg.deviceId,
          countryId: queryArg.countryId,
          site: queryArg.site,
          exlude_ids: queryArg.exludeIds,
        },
      }),
    }),
    getDecloakCountry: build.query<GetDecloakCountryApiResponse, GetDecloakCountryApiArg>({
      query: () => ({ url: '/decloak/country' }),
    }),
    getDomainTagList: build.query<GetDomainTagListApiResponse, GetDomainTagListApiArg>({
      query: (queryArg) => ({
        url: '/domain-tag/list',
        params: {
          project_id: queryArg.projectId,
        },
      }),
    }),
    postDomainTagCreate: build.mutation<PostDomainTagCreateApiResponse, PostDomainTagCreateApiArg>({
      query: (queryArg) => ({ url: '/domain-tag/create', method: 'POST', body: queryArg.body }),
    }),
    postDomainTagUpdate: build.mutation<PostDomainTagUpdateApiResponse, PostDomainTagUpdateApiArg>({
      query: (queryArg) => ({ url: '/domain-tag/update', method: 'POST', body: queryArg.body }),
    }),
    postDomainTagDelete: build.mutation<PostDomainTagDeleteApiResponse, PostDomainTagDeleteApiArg>({
      query: (queryArg) => ({ url: '/domain-tag/delete', method: 'POST', body: queryArg.body }),
    }),
    postDomainTagAssign: build.mutation<PostDomainTagAssignApiResponse, PostDomainTagAssignApiArg>({
      query: (queryArg) => ({ url: '/domain-tag/assign', method: 'POST', body: queryArg.body }),
    }),
    postDomainTagUnassign: build.mutation<
      PostDomainTagUnassignApiResponse,
      PostDomainTagUnassignApiArg
    >({
      query: (queryArg) => ({ url: '/domain-tag/unassign', method: 'POST', body: queryArg.body }),
    }),
    getDomainTagByDomain: build.query<GetDomainTagByDomainApiResponse, GetDomainTagByDomainApiArg>({
      query: (queryArg) => ({
        url: '/domain-tag/by-domain',
        params: {
          project_id: queryArg.projectId,
          domain: queryArg.domain,
        },
      }),
    }),
    getExportReportsAllAdvertisers: build.query<
      GetExportReportsAllAdvertisersApiResponse,
      GetExportReportsAllAdvertisersApiArg
    >({
      query: (queryArg) => ({
        url: '/export-reports/all-advertisers',
        params: {
          export: queryArg['export'],
          exportColumns: queryArg.exportColumns,
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          date: queryArg.date,
          project_id: queryArg.projectId,
          policy: queryArg.policy,
          country_id: queryArg.countryId,
          site: queryArg.site,
          affiliate: queryArg.affiliate,
          affiliate_id: queryArg.affiliateId,
          browser_id: queryArg.browserId,
          device_id: queryArg.deviceId,
          engine_id: queryArg.engineId,
          keyword: queryArg.keyword,
          keyword_id: queryArg.keywordId,
          show_hidden: queryArg.showHidden,
          status: queryArg.status,
          show_affiliates: queryArg.showAffiliates,
          show_shopping_ads: queryArg.showShoppingAds,
          is_decloak: queryArg.isDecloak,
          is_top: queryArg.isTop,
          tag_ids: queryArg.tagIds,
          advertiser_name: queryArg.advertiserName,
          advertiser_id: queryArg.advertiserId,
          reversed_filters: queryArg.reversedFilters,
        },
      }),
    }),
    getExportReportsDomainAdvertisers: build.query<
      GetExportReportsDomainAdvertisersApiResponse,
      GetExportReportsDomainAdvertisersApiArg
    >({
      query: (queryArg) => ({
        url: '/export-reports/domain-advertisers',
        params: {
          project_id: queryArg.projectId,
          site: queryArg.site,
          date: queryArg.date,
          country_id: queryArg.countryId,
          engine_id: queryArg.engineId,
          browser_id: queryArg.browserId,
          device_id: queryArg.deviceId,
          keyword: queryArg.keyword,
          keyword_id: queryArg.keywordId,
          affiliate: queryArg.affiliate,
          affiliate_id: queryArg.affiliateId,
          advertiser_name: queryArg.advertiserName,
          advertiser_id: queryArg.advertiserId,
          policy: queryArg.policy,
          show_shopping_ads: queryArg.showShoppingAds,
          reversed_filters: queryArg.reversedFilters,
          export: queryArg['export'],
          exportColumns: queryArg.exportColumns,
        },
      }),
    }),
    getExportReportsAffiliates: build.query<
      GetExportReportsAffiliatesApiResponse,
      GetExportReportsAffiliatesApiArg
    >({
      query: (queryArg) => ({
        url: '/export-reports/affiliates',
        params: {
          browser_id: queryArg.browserId,
          country_id: queryArg.countryId,
          date: queryArg.date,
          engine_id: queryArg.engineId,
          export: queryArg['export'],
          exportColumns: queryArg.exportColumns,
          is_decloak: queryArg.isDecloak,
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          policy: queryArg.policy,
          project_id: queryArg.projectId,
          show_affiliates: queryArg.showAffiliates,
          show_hidden: queryArg.showHidden,
          status: queryArg.status,
        },
      }),
    }),
    getExportReportsAffiliateLastAd: build.query<
      GetExportReportsAffiliateLastAdApiResponse,
      GetExportReportsAffiliateLastAdApiArg
    >({
      query: (queryArg) => ({
        url: '/export-reports/affiliate-last-ad',
        params: {
          id: queryArg.id,
          project_id: queryArg.projectId,
          country_id: queryArg.countryId,
          engine_id: queryArg.engineId,
          city_id: queryArg.cityId,
          browser_id: queryArg.browserId,
          os_id: queryArg.osId,
          site: queryArg.site,
          keyword: queryArg.keyword,
          advertiser_name: queryArg.advertiserName,
          advertiser_id: queryArg.advertiserId,
          reversed_filters: queryArg.reversedFilters,
          date: queryArg.date,
          is_hijack: queryArg.isHijack,
          show_shopping_ads: queryArg.showShoppingAds,
          is_top: queryArg.isTop,
          affiliate: queryArg.affiliate,
        },
      }),
    }),
    getExportReportsAffiliateAds: build.query<
      GetExportReportsAffiliateAdsApiResponse,
      GetExportReportsAffiliateAdsApiArg
    >({
      query: (queryArg) => ({
        url: '/export-reports/affiliate-ads',
        params: {
          project_id: queryArg.projectId,
          affiliate: queryArg.affiliate,
          country_id: queryArg.countryId,
          site: queryArg.site,
          browser_id: queryArg.browserId,
          engine_id: queryArg.engineId,
          city_id: queryArg.cityId,
          is_hijack: queryArg.isHijack,
          advertiser_name: queryArg.advertiserName,
          affiliate_id: queryArg.affiliateId,
          advertiser_id: queryArg.advertiserId,
          reversed_filters: queryArg.reversedFilters,
          export: queryArg['export'],
          date: queryArg.date,
        },
      }),
    }),
    getExportReportsNonCompliantAffiliates: build.query<
      GetExportReportsNonCompliantAffiliatesApiResponse,
      GetExportReportsNonCompliantAffiliatesApiArg
    >({
      query: (queryArg) => ({
        url: '/export-reports/non-compliant-affiliates',
        params: {
          project_id: queryArg.projectId,
          date: queryArg.date,
          status_id: queryArg.statusId,
          network_id: queryArg.networkId,
          is_hidden: queryArg.isHidden,
          is_hijack: queryArg.isHijack,
          aff_ids: queryArg.affIds,
          site: queryArg.site,
          affiliate: queryArg.affiliate,
          affiliate_id: queryArg.affiliateId,
          affiliate_rule_id: queryArg.affiliateRuleId,
          advertiser_name: queryArg.advertiserName,
          advertiser_id: queryArg.advertiserId,
          keyword: queryArg.keyword,
          network: queryArg.network,
          browser_id: queryArg.browserId,
          country_id: queryArg.countryId,
          engine_id: queryArg.engineId,
          city_id: queryArg.cityId,
          os_id: queryArg.osId,
          show_shopping_ads: queryArg.showShoppingAds,
          reversed_filters: queryArg.reversedFilters,
          export: queryArg['export'],
          exportColumns: queryArg.exportColumns,
          page: queryArg.page,
          'per-page': queryArg['per-page'],
        },
      }),
    }),
    getFeaturesDecloak: build.query<GetFeaturesDecloakApiResponse, GetFeaturesDecloakApiArg>({
      query: (queryArg) => ({
        url: '/features/decloak',
        params: {
          deviceId: queryArg.deviceId,
          countryId: queryArg.countryId,
          site: queryArg.site,
          cache: queryArg.cache,
          notExclusive: queryArg.notExclusive,
          workerType: queryArg.workerType,
        },
      }),
    }),
    getFilterProjects: build.query<GetFilterProjectsApiResponse, GetFilterProjectsApiArg>({
      query: (queryArg) => ({
        url: '/filter/projects',
        params: {
          all: queryArg.all,
        },
      }),
    }),
    getFilterCountry: build.query<GetFilterCountryApiResponse, GetFilterCountryApiArg>({
      query: (queryArg) => ({
        url: '/filter/country',
        params: {
          project_id: queryArg.projectId,
          projects_countries_priority: queryArg.projectsCountriesPriority,
          only_active_projects: queryArg.onlyActiveProjects,
          with_keywords_state: queryArg.withKeywordsState,
        },
      }),
    }),
    getFilterAdvertiserDomains: build.query<
      GetFilterAdvertiserDomainsApiResponse,
      GetFilterAdvertiserDomainsApiArg
    >({
      query: (queryArg) => ({
        url: '/filter/advertiser-domains',
        params: {
          search: queryArg.search,
          project_id: queryArg.projectId,
          seo: queryArg.seo,
          date: queryArg.date,
        },
      }),
    }),
    getFilterAdvertiserLanding: build.query<
      GetFilterAdvertiserLandingApiResponse,
      GetFilterAdvertiserLandingApiArg
    >({
      query: (queryArg) => ({
        url: '/filter/advertiser-landing',
        params: {
          search: queryArg.search,
          project_id: queryArg.projectId,
          date: queryArg.date,
        },
      }),
    }),
    getFilterCity: build.query<GetFilterCityApiResponse, GetFilterCityApiArg>({
      query: (queryArg) => ({
        url: '/filter/city',
        params: {
          project_id: queryArg.projectId,
          country_id: queryArg.countryId,
          all: queryArg.all,
        },
      }),
    }),
    getFilterEngine: build.query<GetFilterEngineApiResponse, GetFilterEngineApiArg>({
      query: (queryArg) => ({
        url: '/filter/engine',
        params: {
          project_id: queryArg.projectId,
        },
      }),
    }),
    getFilterEngineLiveSearch: build.query<
      GetFilterEngineLiveSearchApiResponse,
      GetFilterEngineLiveSearchApiArg
    >({
      query: () => ({ url: '/filter/engine-live-search' }),
    }),
    getFilterBrowser: build.query<GetFilterBrowserApiResponse, GetFilterBrowserApiArg>({
      query: () => ({ url: '/filter/browser' }),
    }),
    getFilterDevices: build.query<GetFilterDevicesApiResponse, GetFilterDevicesApiArg>({
      query: () => ({ url: '/filter/devices' }),
    }),
    getFilterDeviceTypes: build.query<GetFilterDeviceTypesApiResponse, GetFilterDeviceTypesApiArg>({
      query: () => ({ url: '/filter/device-types' }),
    }),
    getFilterAdsTypes: build.query<GetFilterAdsTypesApiResponse, GetFilterAdsTypesApiArg>({
      query: () => ({ url: '/filter/ads-types' }),
    }),
    getFilterKeywords: build.query<GetFilterKeywordsApiResponse, GetFilterKeywordsApiArg>({
      query: (queryArg) => ({
        url: '/filter/keywords',
        params: {
          project_id: queryArg.projectId,
          country_id: queryArg.countryId,
          search: queryArg.search,
        },
      }),
    }),
    getFilterAffiliates: build.query<GetFilterAffiliatesApiResponse, GetFilterAffiliatesApiArg>({
      query: (queryArg) => ({
        url: '/filter/affiliates',
        params: {
          date: queryArg.date,
          project_id: queryArg.projectId,
          is_seo: queryArg.isSeo,
          site_id: queryArg.siteId,
          search: queryArg.search,
        },
      }),
    }),
    getFilterPolicy: build.query<GetFilterPolicyApiResponse, GetFilterPolicyApiArg>({
      query: () => ({ url: '/filter/policy' }),
    }),
    getFilterOwnDomains: build.query<GetFilterOwnDomainsApiResponse, GetFilterOwnDomainsApiArg>({
      query: (queryArg) => ({
        url: '/filter/own-domains',
        params: {
          project_id: queryArg.projectId,
        },
      }),
    }),
    getFilterAffiliateStatus: build.query<
      GetFilterAffiliateStatusApiResponse,
      GetFilterAffiliateStatusApiArg
    >({
      query: (queryArg) => ({
        url: '/filter/affiliate-status',
        params: {
          all: queryArg.all,
        },
      }),
    }),
    getFilterNetwork: build.query<GetFilterNetworkApiResponse, GetFilterNetworkApiArg>({
      query: (queryArg) => ({
        url: '/filter/network',
        params: {
          project_id: queryArg.projectId,
        },
      }),
    }),
    getFilterProjectStatus: build.query<
      GetFilterProjectStatusApiResponse,
      GetFilterProjectStatusApiArg
    >({
      query: () => ({ url: '/filter/project-status' }),
    }),
    getFilterBrowserLanguage: build.query<
      GetFilterBrowserLanguageApiResponse,
      GetFilterBrowserLanguageApiArg
    >({
      query: (queryArg) => ({
        url: '/filter/browser-language',
        params: {
          country_id: queryArg.countryId,
        },
      }),
    }),
    getFilterCompany: build.query<GetFilterCompanyApiResponse, GetFilterCompanyApiArg>({
      query: () => ({ url: '/filter/company' }),
    }),
    getFilterCompanyRole: build.query<GetFilterCompanyRoleApiResponse, GetFilterCompanyRoleApiArg>({
      query: () => ({ url: '/filter/company-role' }),
    }),
    getFilterAssistanceRequest: build.query<
      GetFilterAssistanceRequestApiResponse,
      GetFilterAssistanceRequestApiArg
    >({
      query: () => ({ url: '/filter/assistance-request' }),
    }),
    getFilterSubRoles: build.query<GetFilterSubRolesApiResponse, GetFilterSubRolesApiArg>({
      query: () => ({ url: '/filter/sub-roles' }),
    }),
    getFilterDomainZones: build.query<GetFilterDomainZonesApiResponse, GetFilterDomainZonesApiArg>({
      query: () => ({ url: '/filter/domain-zones' }),
    }),
    getFilterContactMethod: build.query<
      GetFilterContactMethodApiResponse,
      GetFilterContactMethodApiArg
    >({
      query: () => ({ url: '/filter/contact-method' }),
    }),
    getFilterPayoutStatus: build.query<
      GetFilterPayoutStatusApiResponse,
      GetFilterPayoutStatusApiArg
    >({
      query: () => ({ url: '/filter/payout-status' }),
    }),
    getFilterAdvertiserNames: build.query<
      GetFilterAdvertiserNamesApiResponse,
      GetFilterAdvertiserNamesApiArg
    >({
      query: (queryArg) => ({
        url: '/filter/advertiser-names',
        params: {
          search: queryArg.search,
          project_id: queryArg.projectId,
          date: queryArg.date,
        },
      }),
    }),
    getFilterTrademark: build.query<GetFilterTrademarkApiResponse, GetFilterTrademarkApiArg>({
      query: (queryArg) => ({
        url: '/filter/trademark',
        params: {
          project_id: queryArg.projectId,
        },
      }),
    }),
    getFilterCaseId: build.query<GetFilterCaseIdApiResponse, GetFilterCaseIdApiArg>({
      query: (queryArg) => ({
        url: '/filter/case-id',
        params: {
          project_id: queryArg.projectId,
          trademark_id: queryArg.trademarkId,
          search: queryArg.search,
        },
      }),
    }),
    getFilterTmReplyType: build.query<GetFilterTmReplyTypeApiResponse, GetFilterTmReplyTypeApiArg>({
      query: () => ({ url: '/filter/tm-reply-type' }),
    }),
    getFilterTmInfringementDomains: build.query<
      GetFilterTmInfringementDomainsApiResponse,
      GetFilterTmInfringementDomainsApiArg
    >({
      query: (queryArg) => ({
        url: '/filter/tm-infringement-domains',
        params: {
          project_id: queryArg.projectId,
          trademark_id: queryArg.trademarkId,
          search: queryArg.search,
          tab: queryArg.tab,
          status: queryArg.status,
          country_id: queryArg.countryId,
          engine_id: queryArg.engineId,
          only_registered: queryArg.onlyRegistered,
          show_whitelisted: queryArg.showWhitelisted,
          date: queryArg.date,
        },
      }),
    }),
    getFilterAlertType: build.query<GetFilterAlertTypeApiResponse, GetFilterAlertTypeApiArg>({
      query: () => ({ url: '/filter/alert-type' }),
    }),
    getFilterNotificationDeliveryMode: build.query<
      GetFilterNotificationDeliveryModeApiResponse,
      GetFilterNotificationDeliveryModeApiArg
    >({
      query: () => ({ url: '/filter/notification-delivery-mode' }),
    }),
    getFilterNotificationFrequency: build.query<
      GetFilterNotificationFrequencyApiResponse,
      GetFilterNotificationFrequencyApiArg
    >({
      query: () => ({ url: '/filter/notification-frequency' }),
    }),
    getFilterNotificationChannel: build.query<
      GetFilterNotificationChannelApiResponse,
      GetFilterNotificationChannelApiArg
    >({
      query: () => ({ url: '/filter/notification-channel' }),
    }),
    getFilterWeekday: build.query<GetFilterWeekdayApiResponse, GetFilterWeekdayApiArg>({
      query: () => ({ url: '/filter/weekday' }),
    }),
    getFilterTimezone: build.query<GetFilterTimezoneApiResponse, GetFilterTimezoneApiArg>({
      query: () => ({ url: '/filter/timezone' }),
    }),
    getLanguageComplianceLastCheck: build.query<
      GetLanguageComplianceLastCheckApiResponse,
      GetLanguageComplianceLastCheckApiArg
    >({
      query: (queryArg) => ({
        url: '/language-compliance/last-check',
        params: {
          project_id: queryArg.projectId,
          country_id: queryArg.countryId,
          date: queryArg.date,
          device_id: queryArg.deviceId,
          url: queryArg.url,
          url_id: queryArg.urlId,
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          affiliate: queryArg.affiliate,
          word_id: queryArg.wordId,
          show_hidden: queryArg.showHidden,
          manual_only: queryArg.manualOnly,
        },
      }),
    }),
    getLanguageComplianceInProgress: build.query<
      GetLanguageComplianceInProgressApiResponse,
      GetLanguageComplianceInProgressApiArg
    >({
      query: (queryArg) => ({
        url: '/language-compliance/in-progress',
        params: {
          project_id: queryArg.projectId,
          country_id: queryArg.countryId,
          date: queryArg.date,
          device_id: queryArg.deviceId,
          url: queryArg.url,
          url_id: queryArg.urlId,
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          affiliate: queryArg.affiliate,
          word_id: queryArg.wordId,
          show_hidden: queryArg.showHidden,
          manual_only: queryArg.manualOnly,
        },
      }),
    }),
    getLanguageComplianceHistory: build.query<
      GetLanguageComplianceHistoryApiResponse,
      GetLanguageComplianceHistoryApiArg
    >({
      query: (queryArg) => ({
        url: '/language-compliance/history',
        params: {
          project_id: queryArg.projectId,
          country_id: queryArg.countryId,
          date: queryArg.date,
          device_id: queryArg.deviceId,
          url: queryArg.url,
          url_id: queryArg.urlId,
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          affiliate: queryArg.affiliate,
          word_id: queryArg.wordId,
          show_hidden: queryArg.showHidden,
          manual_only: queryArg.manualOnly,
        },
      }),
    }),
    getLanguageComplianceCounter: build.query<
      GetLanguageComplianceCounterApiResponse,
      GetLanguageComplianceCounterApiArg
    >({
      query: (queryArg) => ({
        url: '/language-compliance/counter',
        params: {
          project_id: queryArg.projectId,
          country_id: queryArg.countryId,
          date: queryArg.date,
          device_id: queryArg.deviceId,
          url: queryArg.url,
          url_id: queryArg.urlId,
          affiliate: queryArg.affiliate,
          word_id: queryArg.wordId,
          show_hidden: queryArg.showHidden,
          manual_only: queryArg.manualOnly,
        },
      }),
    }),
    getLanguageComplianceHistoryDetail: build.query<
      GetLanguageComplianceHistoryDetailApiResponse,
      GetLanguageComplianceHistoryDetailApiArg
    >({
      query: (queryArg) => ({
        url: '/language-compliance/history-detail',
        params: {
          project_id: queryArg.projectId,
          country_id: queryArg.countryId,
          date: queryArg.date,
          device_id: queryArg.deviceId,
          url: queryArg.url,
          url_id: queryArg.urlId,
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          affiliate: queryArg.affiliate,
          word_id: queryArg.wordId,
          show_hidden: queryArg.showHidden,
          manual_only: queryArg.manualOnly,
        },
      }),
    }),
    getLanguageComplianceReport: build.query<
      GetLanguageComplianceReportApiResponse,
      GetLanguageComplianceReportApiArg
    >({
      query: (queryArg) => ({
        url: '/language-compliance/report',
        params: {
          id: queryArg.id,
        },
      }),
    }),
    getLanguageComplianceExport: build.query<
      GetLanguageComplianceExportApiResponse,
      GetLanguageComplianceExportApiArg
    >({
      query: (queryArg) => ({
        url: '/language-compliance/export',
        params: {
          project_id: queryArg.projectId,
          country_id: queryArg.countryId,
          date: queryArg.date,
          device_id: queryArg.deviceId,
          url: queryArg.url,
          url_id: queryArg.urlId,
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          affiliate: queryArg.affiliate,
          word_id: queryArg.wordId,
          show_hidden: queryArg.showHidden,
          manual_only: queryArg.manualOnly,
        },
      }),
    }),
    getLanguageComplianceFilterProject: build.query<
      GetLanguageComplianceFilterProjectApiResponse,
      GetLanguageComplianceFilterProjectApiArg
    >({
      query: () => ({ url: '/language-compliance/filter-project' }),
    }),
    getLanguageComplianceFilterCountry: build.query<
      GetLanguageComplianceFilterCountryApiResponse,
      GetLanguageComplianceFilterCountryApiArg
    >({
      query: (queryArg) => ({
        url: '/language-compliance/filter-country',
        params: {
          project_id: queryArg.projectId,
        },
      }),
    }),
    getLanguageComplianceFilterPage: build.query<
      GetLanguageComplianceFilterPageApiResponse,
      GetLanguageComplianceFilterPageApiArg
    >({
      query: (queryArg) => ({
        url: '/language-compliance/filter-page',
        params: {
          project_id: queryArg.projectId,
        },
      }),
    }),
    getLanguageComplianceFilterAffiliate: build.query<
      GetLanguageComplianceFilterAffiliateApiResponse,
      GetLanguageComplianceFilterAffiliateApiArg
    >({
      query: (queryArg) => ({
        url: '/language-compliance/filter-affiliate',
        params: {
          project_id: queryArg.projectId,
        },
      }),
    }),
    getLanguageComplianceFilterWord: build.query<
      GetLanguageComplianceFilterWordApiResponse,
      GetLanguageComplianceFilterWordApiArg
    >({
      query: (queryArg) => ({
        url: '/language-compliance/filter-word',
        params: {
          project_id: queryArg.projectId,
        },
      }),
    }),
    postLanguageComplianceUpdateState: build.mutation<
      PostLanguageComplianceUpdateStateApiResponse,
      PostLanguageComplianceUpdateStateApiArg
    >({
      query: (queryArg) => ({
        url: '/language-compliance/update-state',
        method: 'POST',
        body: queryArg.stateForm,
      }),
    }),
    postN8NSendMessage: build.mutation<PostN8NSendMessageApiResponse, PostN8NSendMessageApiArg>({
      query: (queryArg) => ({ url: '/n8n/send-message', method: 'POST', body: queryArg.body }),
    }),
    getNotificationState: build.query<GetNotificationStateApiResponse, GetNotificationStateApiArg>({
      query: (queryArg) => ({
        url: '/notification/state',
        params: {
          project_id: queryArg.projectId,
        },
      }),
    }),
    getNotificationSchedule: build.query<
      GetNotificationScheduleApiResponse,
      GetNotificationScheduleApiArg
    >({
      query: (queryArg) => ({
        url: '/notification/schedule',
        params: {
          project_id: queryArg.projectId,
          type: queryArg['type'],
        },
      }),
    }),
    postNotificationSaveSchedule: build.mutation<
      PostNotificationSaveScheduleApiResponse,
      PostNotificationSaveScheduleApiArg
    >({
      query: (queryArg) => ({
        url: '/notification/save-schedule',
        method: 'POST',
        body: queryArg.notificationScheduleForm,
      }),
    }),
    postNotificationSaveCard: build.mutation<
      PostNotificationSaveCardApiResponse,
      PostNotificationSaveCardApiArg
    >({
      query: (queryArg) => ({
        url: '/notification/save-card',
        method: 'POST',
        body: queryArg.notificationCardForm,
      }),
    }),
    getProfileInfo: build.query<GetProfileInfoApiResponse, GetProfileInfoApiArg>({
      query: () => ({ url: '/profile/info' }),
    }),
    postProfileInfo: build.mutation<PostProfileInfoApiResponse, PostProfileInfoApiArg>({
      query: (queryArg) => ({ url: '/profile/info', method: 'POST', body: queryArg.profileForm }),
    }),
    postProfileChangeEmail: build.mutation<
      PostProfileChangeEmailApiResponse,
      PostProfileChangeEmailApiArg
    >({
      query: (queryArg) => ({
        url: '/profile/change-email',
        method: 'POST',
        body: queryArg.changeEmailForm,
      }),
    }),
    postProfileChangePassword: build.mutation<
      PostProfileChangePasswordApiResponse,
      PostProfileChangePasswordApiArg
    >({
      query: (queryArg) => ({
        url: '/profile/change-password',
        method: 'POST',
        body: queryArg.changePasswordForm,
      }),
    }),
    postProfileMenuPosition: build.mutation<
      PostProfileMenuPositionApiResponse,
      PostProfileMenuPositionApiArg
    >({
      query: (queryArg) => ({ url: '/profile/menu-position', method: 'POST', body: queryArg.body }),
    }),
    postProjectCreate: build.mutation<PostProjectCreateApiResponse, PostProjectCreateApiArg>({
      query: (queryArg) => ({ url: '/project/create', method: 'POST', body: queryArg.body }),
    }),
    getProjectList: build.query<GetProjectListApiResponse, GetProjectListApiArg>({
      query: (queryArg) => ({
        url: '/project/list',
        params: {
          project_id: queryArg.projectId,
          project_ids: queryArg.projectIds,
          country_id: queryArg.countryId,
          status: queryArg.status,
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          sort: queryArg.sort,
        },
      }),
    }),
    postProjectUpdateStatus: build.mutation<
      PostProjectUpdateStatusApiResponse,
      PostProjectUpdateStatusApiArg
    >({
      query: (queryArg) => ({ url: '/project/update-status', method: 'POST', body: queryArg.body }),
    }),
    getProjectInfo: build.query<GetProjectInfoApiResponse, GetProjectInfoApiArg>({
      query: (queryArg) => ({
        url: '/project/info',
        params: {
          id: queryArg.id,
        },
      }),
    }),
    postProjectUpdateInfo: build.mutation<
      PostProjectUpdateInfoApiResponse,
      PostProjectUpdateInfoApiArg
    >({
      query: (queryArg) => ({ url: '/project/update-info', method: 'POST', body: queryArg.body }),
    }),
    getProjectMainSettings: build.query<
      GetProjectMainSettingsApiResponse,
      GetProjectMainSettingsApiArg
    >({
      query: (queryArg) => ({
        url: '/project/main-settings',
        params: {
          id: queryArg.id,
        },
      }),
    }),
    postProjectUpdateMainSettings: build.mutation<
      PostProjectUpdateMainSettingsApiResponse,
      PostProjectUpdateMainSettingsApiArg
    >({
      query: (queryArg) => ({
        url: '/project/update-main-settings',
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getProjectLocations: build.query<GetProjectLocationsApiResponse, GetProjectLocationsApiArg>({
      query: (queryArg) => ({
        url: '/project/locations',
        params: {
          project_id: queryArg.projectId,
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          sort: queryArg.sort,
        },
      }),
    }),
    postProjectUpdateLocations: build.mutation<
      PostProjectUpdateLocationsApiResponse,
      PostProjectUpdateLocationsApiArg
    >({
      query: (queryArg) => ({
        url: '/project/update-locations',
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getProjectAvailableCountries: build.query<
      GetProjectAvailableCountriesApiResponse,
      GetProjectAvailableCountriesApiArg
    >({
      query: (queryArg) => ({
        url: '/project/available-countries',
        params: {
          project_id: queryArg.projectId,
        },
      }),
    }),
    getProjectLocationsDefaultSettings: build.query<
      GetProjectLocationsDefaultSettingsApiResponse,
      GetProjectLocationsDefaultSettingsApiArg
    >({
      query: (queryArg) => ({
        url: '/project/locations-default-settings',
        params: {
          country_ids: queryArg.countryIds,
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          sort: queryArg.sort,
        },
      }),
    }),
    getProjectTerms: build.query<GetProjectTermsApiResponse, GetProjectTermsApiArg>({
      query: (queryArg) => ({
        url: '/project/terms',
        params: {
          project_id: queryArg.projectId,
        },
      }),
    }),
    postProjectUpdateTerms: build.mutation<
      PostProjectUpdateTermsApiResponse,
      PostProjectUpdateTermsApiArg
    >({
      query: (queryArg) => ({ url: '/project/update-terms', method: 'POST', body: queryArg.body }),
    }),
    postProjectSendWeeklyReportTelegram: build.mutation<
      PostProjectSendWeeklyReportTelegramApiResponse,
      PostProjectSendWeeklyReportTelegramApiArg
    >({
      query: (queryArg) => ({
        url: '/project/send-weekly-report-telegram',
        method: 'POST',
        params: {
          project_id: queryArg.projectId,
        },
      }),
    }),
    postProjectSendWeeklyReportEmail: build.mutation<
      PostProjectSendWeeklyReportEmailApiResponse,
      PostProjectSendWeeklyReportEmailApiArg
    >({
      query: (queryArg) => ({
        url: '/project/send-weekly-report-email',
        method: 'POST',
        params: {
          project_id: queryArg.projectId,
        },
      }),
    }),
    postProjectSendAlertTelegram: build.mutation<
      PostProjectSendAlertTelegramApiResponse,
      PostProjectSendAlertTelegramApiArg
    >({
      query: (queryArg) => ({
        url: '/project/send-alert-telegram',
        method: 'POST',
        params: {
          project_id: queryArg.projectId,
        },
      }),
    }),
    postProjectSendAlertEmail: build.mutation<
      PostProjectSendAlertEmailApiResponse,
      PostProjectSendAlertEmailApiArg
    >({
      query: (queryArg) => ({
        url: '/project/send-alert-email',
        method: 'POST',
        params: {
          project_id: queryArg.projectId,
        },
      }),
    }),
    postProjectSendTmAlertTelegram: build.mutation<
      PostProjectSendTmAlertTelegramApiResponse,
      PostProjectSendTmAlertTelegramApiArg
    >({
      query: (queryArg) => ({
        url: '/project/send-tm-alert-telegram',
        method: 'POST',
        params: {
          project_id: queryArg.projectId,
        },
      }),
    }),
    postProjectSendTmAlertEmail: build.mutation<
      PostProjectSendTmAlertEmailApiResponse,
      PostProjectSendTmAlertEmailApiArg
    >({
      query: (queryArg) => ({
        url: '/project/send-tm-alert-email',
        method: 'POST',
        params: {
          project_id: queryArg.projectId,
        },
      }),
    }),
    getProjectDownloadReport: build.query<
      GetProjectDownloadReportApiResponse,
      GetProjectDownloadReportApiArg
    >({
      query: (queryArg) => ({
        url: '/project/download-report',
        params: {
          project_id: queryArg.projectId,
        },
      }),
    }),
    getProjectBrandDomains: build.query<
      GetProjectBrandDomainsApiResponse,
      GetProjectBrandDomainsApiArg
    >({
      query: (queryArg) => ({
        url: '/project/brand-domains',
        params: {
          project_id: queryArg.projectId,
          url: queryArg.url,
        },
      }),
    }),
    postProjectDeleteDemoProject: build.mutation<
      PostProjectDeleteDemoProjectApiResponse,
      PostProjectDeleteDemoProjectApiArg
    >({
      query: () => ({ url: '/project/delete-demo-project', method: 'POST' }),
    }),
    postReferralCreateLink: build.mutation<
      PostReferralCreateLinkApiResponse,
      PostReferralCreateLinkApiArg
    >({
      query: () => ({ url: '/referral/create-link', method: 'POST' }),
    }),
    postReferralDeleteLink: build.mutation<
      PostReferralDeleteLinkApiResponse,
      PostReferralDeleteLinkApiArg
    >({
      query: (queryArg) => ({
        url: '/referral/delete-link',
        method: 'POST',
        params: {
          id: queryArg.id,
        },
      }),
    }),
    postReferralClick: build.mutation<PostReferralClickApiResponse, PostReferralClickApiArg>({
      query: (queryArg) => ({
        url: '/referral/click',
        method: 'POST',
        params: {
          code: queryArg.code,
          ref_cookie_id: queryArg.refCookieId,
        },
      }),
    }),
    getReferralLinkList: build.query<GetReferralLinkListApiResponse, GetReferralLinkListApiArg>({
      query: () => ({ url: '/referral/link-list' }),
    }),
    getReferralUserList: build.query<GetReferralUserListApiResponse, GetReferralUserListApiArg>({
      query: () => ({ url: '/referral/user-list' }),
    }),
    getReferralBalance: build.query<GetReferralBalanceApiResponse, GetReferralBalanceApiArg>({
      query: () => ({ url: '/referral/balance' }),
    }),
    getReferralConversionStat: build.query<
      GetReferralConversionStatApiResponse,
      GetReferralConversionStatApiArg
    >({
      query: (queryArg) => ({
        url: '/referral/conversion-stat',
        params: {
          date: queryArg.date,
        },
      }),
    }),
    getReferralStatByMonth: build.query<
      GetReferralStatByMonthApiResponse,
      GetReferralStatByMonthApiArg
    >({
      query: (queryArg) => ({
        url: '/referral/stat-by-month',
        params: {
          year: queryArg.year,
        },
      }),
    }),
    postReferralPayoutRequest: build.mutation<
      PostReferralPayoutRequestApiResponse,
      PostReferralPayoutRequestApiArg
    >({
      query: () => ({ url: '/referral/payout-request', method: 'POST' }),
    }),
    getReferralPayoutsList: build.query<
      GetReferralPayoutsListApiResponse,
      GetReferralPayoutsListApiArg
    >({
      query: () => ({ url: '/referral/payouts-list' }),
    }),
    getReferralTerms: build.query<GetReferralTermsApiResponse, GetReferralTermsApiArg>({
      query: () => ({ url: '/referral/terms' }),
    }),
    getResearchKeywords: build.query<GetResearchKeywordsApiResponse, GetResearchKeywordsApiArg>({
      query: (queryArg) => ({
        url: '/research/keywords',
        params: {
          project_ids: queryArg.projectIds,
          country_ids: queryArg.countryIds,
          keyword: queryArg.keyword,
          domain: queryArg.domain,
          ads_count: queryArg.adsCount,
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          sort: queryArg.sort,
          export: queryArg['export'],
          exportColumns: queryArg.exportColumns,
          date: queryArg.date,
        },
      }),
    }),
    getResearchKeywordsDateRange: build.query<
      GetResearchKeywordsDateRangeApiResponse,
      GetResearchKeywordsDateRangeApiArg
    >({
      query: (queryArg) => ({
        url: '/research/keywords-date-range',
        params: {
          project_ids: queryArg.projectIds,
          country_ids: queryArg.countryIds,
          keyword: queryArg.keyword,
          domain: queryArg.domain,
          ads_count: queryArg.adsCount,
          date: queryArg.date,
        },
      }),
    }),
    postResearchKeywordsChart: build.mutation<
      PostResearchKeywordsChartApiResponse,
      PostResearchKeywordsChartApiArg
    >({
      query: (queryArg) => ({
        url: '/research/keywords-chart',
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getResearchCompetitors: build.query<
      GetResearchCompetitorsApiResponse,
      GetResearchCompetitorsApiArg
    >({
      query: (queryArg) => ({
        url: '/research/competitors',
        params: {
          project_ids: queryArg.projectIds,
          country_ids: queryArg.countryIds,
          domain: queryArg.domain,
          kinds: queryArg.kinds,
          sub_kinds: queryArg.subKinds,
          kind: queryArg.kind,
          sub_kind: queryArg.subKind,
          ads_count: queryArg.adsCount,
          sw_visits: queryArg.swVisits,
          visibility: queryArg.visibility,
          is_ignored: queryArg.isIgnored,
          is_ppc: queryArg.isPpc,
          id: queryArg.id,
          priority_vendor_id: queryArg.priorityVendorId,
          created_at: queryArg.createdAt,
          notice: queryArg.notice,
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          sort: queryArg.sort,
          export: queryArg['export'],
          exportColumns: queryArg.exportColumns,
          date: queryArg.date,
        },
      }),
    }),
    getResearchCompetitorsDateRange: build.query<
      GetResearchCompetitorsDateRangeApiResponse,
      GetResearchCompetitorsDateRangeApiArg
    >({
      query: (queryArg) => ({
        url: '/research/competitors-date-range',
        params: {
          project_ids: queryArg.projectIds,
          country_ids: queryArg.countryIds,
          domain: queryArg.domain,
          kinds: queryArg.kinds,
          sub_kinds: queryArg.subKinds,
          kind: queryArg.kind,
          sub_kind: queryArg.subKind,
          ads_count: queryArg.adsCount,
          sw_visits: queryArg.swVisits,
          visibility: queryArg.visibility,
          is_ignored: queryArg.isIgnored,
          is_ppc: queryArg.isPpc,
          id: queryArg.id,
          priority_vendor_id: queryArg.priorityVendorId,
          date: queryArg.date,
        },
      }),
    }),
    postResearchCompetitorsChart: build.mutation<
      PostResearchCompetitorsChartApiResponse,
      PostResearchCompetitorsChartApiArg
    >({
      query: (queryArg) => ({
        url: '/research/competitors-chart',
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getResearchCompetitorsColumn: build.query<
      GetResearchCompetitorsColumnApiResponse,
      GetResearchCompetitorsColumnApiArg
    >({
      query: (queryArg) => ({
        url: '/research/competitors-column',
        params: {
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          sort: queryArg.sort,
          project_id: queryArg.projectId,
          country_id: queryArg.countryId,
          domain: queryArg.domain,
          keyword: queryArg.keyword,
          date: queryArg.date,
          export: queryArg['export'],
        },
      }),
    }),
    getResearchKeywordsColumnAdvertisers: build.query<
      GetResearchKeywordsColumnAdvertisersApiResponse,
      GetResearchKeywordsColumnAdvertisersApiArg
    >({
      query: (queryArg) => ({
        url: '/research/keywords-column-advertisers',
        params: {
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          sort: queryArg.sort,
          project_id: queryArg.projectId,
          country_id: queryArg.countryId,
          keyword: queryArg.keyword,
          date: queryArg.date,
          export: queryArg['export'],
        },
      }),
    }),
    getResearchAdvertising: build.query<
      GetResearchAdvertisingApiResponse,
      GetResearchAdvertisingApiArg
    >({
      query: (queryArg) => ({
        url: '/research/advertising',
        params: {
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          sort: queryArg.sort,
          export: queryArg['export'],
          exportColumns: queryArg.exportColumns,
          date: queryArg.date,
          project_id: queryArg.projectId,
          site: queryArg.site,
          country_id: queryArg.countryId,
          engine_id: queryArg.engineId,
          keyword: queryArg.keyword,
          keyword_id: queryArg.keywordId,
          landing: queryArg.landing,
          landing_id: queryArg.landingId,
          has_brand: queryArg.hasBrand,
          show_hidden: queryArg.showHidden,
          reversed_filters: queryArg.reversedFilters,
        },
      }),
    }),
    getResearchAdvertisingKeyword: build.query<
      GetResearchAdvertisingKeywordApiResponse,
      GetResearchAdvertisingKeywordApiArg
    >({
      query: (queryArg) => ({
        url: '/research/advertising-keyword',
        params: {
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          sort: queryArg.sort,
          export: queryArg['export'],
          exportColumns: queryArg.exportColumns,
          date: queryArg.date,
          title: queryArg.title,
          url: queryArg.url,
          project_id: queryArg.projectId,
          site: queryArg.site,
          country_id: queryArg.countryId,
          engine_id: queryArg.engineId,
          keyword: queryArg.keyword,
          keyword_id: queryArg.keywordId,
          landing: queryArg.landing,
          landing_id: queryArg.landingId,
          has_brand: queryArg.hasBrand,
          show_hidden: queryArg.showHidden,
          reversed_filters: queryArg.reversedFilters,
        },
      }),
    }),
    getResearchAdvertisingAffiliates: build.query<
      GetResearchAdvertisingAffiliatesApiResponse,
      GetResearchAdvertisingAffiliatesApiArg
    >({
      query: (queryArg) => ({
        url: '/research/advertising-affiliates',
        params: {
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          sort: queryArg.sort,
          export: queryArg['export'],
          exportColumns: queryArg.exportColumns,
          date: queryArg.date,
          project_id: queryArg.projectId,
          site: queryArg.site,
          country_id: queryArg.countryId,
          engine_id: queryArg.engineId,
          keyword: queryArg.keyword,
          keyword_id: queryArg.keywordId,
          landing: queryArg.landing,
          landing_id: queryArg.landingId,
          has_brand: queryArg.hasBrand,
          show_hidden: queryArg.showHidden,
          reversed_filters: queryArg.reversedFilters,
        },
      }),
    }),
    getResearchSeoPosition: build.query<
      GetResearchSeoPositionApiResponse,
      GetResearchSeoPositionApiArg
    >({
      query: (queryArg) => ({
        url: '/research/seo-position',
        params: {
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          sort: queryArg.sort,
          export: queryArg['export'],
          exportColumns: queryArg.exportColumns,
          date: queryArg.date,
          project_id: queryArg.projectId,
          own_domain: queryArg.ownDomain,
          country_id: queryArg.countryId,
          engine_id: queryArg.engineId,
          keyword: queryArg.keyword,
          keyword_id: queryArg.keywordId,
          no_serp_presence: queryArg.noSerpPresence,
          landing: queryArg.landing,
          landing_id: queryArg.landingId,
        },
      }),
    }),
    postResearchSeoPositionChart: build.mutation<
      PostResearchSeoPositionChartApiResponse,
      PostResearchSeoPositionChartApiArg
    >({
      query: (queryArg) => ({
        url: '/research/seo-position-chart',
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getResearchBrandPresence: build.query<
      GetResearchBrandPresenceApiResponse,
      GetResearchBrandPresenceApiArg
    >({
      query: (queryArg) => ({
        url: '/research/brand-presence',
        params: {
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          sort: queryArg.sort,
          export: queryArg['export'],
          exportColumns: queryArg.exportColumns,
          date: queryArg.date,
          project_id: queryArg.projectId,
          country_id: queryArg.countryId,
          engine_id: queryArg.engineId,
          no_serp_presence: queryArg.noSerpPresence,
          site: queryArg.site,
          keyword: queryArg.keyword,
          keyword_id: queryArg.keywordId,
          landing: queryArg.landing,
          landing_id: queryArg.landingId,
        },
      }),
    }),
    getResearchBrandPresencePages: build.query<
      GetResearchBrandPresencePagesApiResponse,
      GetResearchBrandPresencePagesApiArg
    >({
      query: (queryArg) => ({
        url: '/research/brand-presence-pages',
        params: {
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          sort: queryArg.sort,
          export: queryArg['export'],
          exportColumns: queryArg.exportColumns,
          date: queryArg.date,
          project_id: queryArg.projectId,
          keyword_id: queryArg.keywordId,
          country_id: queryArg.countryId,
          engine_id: queryArg.engineId,
          site: queryArg.site,
          landing: queryArg.landing,
          landing_id: queryArg.landingId,
          is_seo: queryArg.isSeo,
        },
      }),
    }),
    getResearchLive: build.query<GetResearchLiveApiResponse, GetResearchLiveApiArg>({
      query: (queryArg) => ({
        url: '/research/live',
        params: {
          deviceTypeId: queryArg.deviceTypeId,
          countryId: queryArg.countryId,
          engineId: queryArg.engineId,
          keyword: queryArg.keyword,
          excludeIds: queryArg.excludeIds,
        },
      }),
    }),
    getResearchLiveRedirects: build.query<
      GetResearchLiveRedirectsApiResponse,
      GetResearchLiveRedirectsApiArg
    >({
      query: (queryArg) => ({
        url: '/research/live-redirects',
        params: {
          deviceTypeId: queryArg.deviceTypeId,
          countryId: queryArg.countryId,
          engineId: queryArg.engineId,
          linkUrl: queryArg.linkUrl,
          linkTitle: queryArg.linkTitle,
          linkText: queryArg.linkText,
          linkDomain: queryArg.linkDomain,
          keyword: queryArg.keyword,
          isSeoLink: queryArg.isSeoLink,
          excludeIds: queryArg.excludeIds,
          hash: queryArg.hash,
          requestType: queryArg.requestType,
          leftAttempts: queryArg.leftAttempts,
        },
      }),
    }),
    getResearchLiveDecloakAuto: build.query<
      GetResearchLiveDecloakAutoApiResponse,
      GetResearchLiveDecloakAutoApiArg
    >({
      query: (queryArg) => ({
        url: '/research/live-decloak-auto',
        params: {
          deviceTypeId: queryArg.deviceTypeId,
          countryId: queryArg.countryId,
          engineId: queryArg.engineId,
          linkUrl: queryArg.linkUrl,
          linkTitle: queryArg.linkTitle,
          linkText: queryArg.linkText,
          linkDomain: queryArg.linkDomain,
          keyword: queryArg.keyword,
          isSeoLink: queryArg.isSeoLink,
        },
      }),
    }),
    postSiteLogin: build.mutation<PostSiteLoginApiResponse, PostSiteLoginApiArg>({
      query: (queryArg) => ({ url: '/site/login', method: 'POST', body: queryArg.body }),
    }),
    postSiteSignup: build.mutation<PostSiteSignupApiResponse, PostSiteSignupApiArg>({
      query: (queryArg) => ({ url: '/site/signup', method: 'POST', body: queryArg.body }),
    }),
    getSiteCurrentuser: build.query<GetSiteCurrentuserApiResponse, GetSiteCurrentuserApiArg>({
      query: () => ({ url: '/site/currentuser' }),
    }),
    postSiteContact: build.mutation<PostSiteContactApiResponse, PostSiteContactApiArg>({
      query: (queryArg) => ({ url: '/site/contact', method: 'POST', body: queryArg.body }),
    }),
    postSiteRequestDemo: build.mutation<PostSiteRequestDemoApiResponse, PostSiteRequestDemoApiArg>({
      query: (queryArg) => ({ url: '/site/request-demo', method: 'POST', body: queryArg.body }),
    }),
    postSiteLogout: build.mutation<PostSiteLogoutApiResponse, PostSiteLogoutApiArg>({
      query: () => ({ url: '/site/logout', method: 'POST' }),
    }),
    postSiteRequestPasswordReset: build.mutation<
      PostSiteRequestPasswordResetApiResponse,
      PostSiteRequestPasswordResetApiArg
    >({
      query: (queryArg) => ({
        url: '/site/request-password-reset',
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    postSiteResetPassword: build.mutation<
      PostSiteResetPasswordApiResponse,
      PostSiteResetPasswordApiArg
    >({
      query: (queryArg) => ({
        url: '/site/reset-password',
        method: 'POST',
        body: queryArg.body,
        params: {
          token: queryArg.token,
          invite: queryArg.invite,
        },
      }),
    }),
    postSiteVerifyEmail: build.mutation<PostSiteVerifyEmailApiResponse, PostSiteVerifyEmailApiArg>({
      query: (queryArg) => ({
        url: '/site/verify-email',
        method: 'POST',
        params: {
          token: queryArg.token,
        },
      }),
    }),
    postSiteGoogleOauth: build.mutation<PostSiteGoogleOauthApiResponse, PostSiteGoogleOauthApiArg>({
      query: (queryArg) => ({
        url: '/site/google-oauth',
        method: 'POST',
        params: {
          credential: queryArg.credential,
          code: queryArg.code,
          state: queryArg.state,
        },
      }),
    }),
    getSiteGoogleReportOauthUrl: build.query<
      GetSiteGoogleReportOauthUrlApiResponse,
      GetSiteGoogleReportOauthUrlApiArg
    >({
      query: () => ({ url: '/site/google-report-oauth-url' }),
    }),
    postSiteGoogleReportOauthSave: build.mutation<
      PostSiteGoogleReportOauthSaveApiResponse,
      PostSiteGoogleReportOauthSaveApiArg
    >({
      query: (queryArg) => ({
        url: '/site/google-report-oauth-save',
        method: 'POST',
        params: {
          code: queryArg.code,
        },
      }),
    }),
    postSiteGoogleReportOauthDeleteToken: build.mutation<
      PostSiteGoogleReportOauthDeleteTokenApiResponse,
      PostSiteGoogleReportOauthDeleteTokenApiArg
    >({
      query: (queryArg) => ({
        url: '/site/google-report-oauth-delete-token',
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    postSiteSendVerificationEmail: build.mutation<
      PostSiteSendVerificationEmailApiResponse,
      PostSiteSendVerificationEmailApiArg
    >({
      query: () => ({ url: '/site/send-verification-email', method: 'POST' }),
    }),
    postSiteHideNotification: build.mutation<
      PostSiteHideNotificationApiResponse,
      PostSiteHideNotificationApiArg
    >({
      query: (queryArg) => ({
        url: '/site/hide-notification',
        method: 'POST',
        params: {
          id: queryArg.id,
        },
      }),
    }),
    getSiteArticleSettings: build.query<
      GetSiteArticleSettingsApiResponse,
      GetSiteArticleSettingsApiArg
    >({
      query: () => ({ url: '/site/article-settings' }),
    }),
    getSiteFaq: build.query<GetSiteFaqApiResponse, GetSiteFaqApiArg>({
      query: () => ({ url: '/site/faq' }),
    }),
    getSiteCustomerReviews: build.query<
      GetSiteCustomerReviewsApiResponse,
      GetSiteCustomerReviewsApiArg
    >({
      query: () => ({ url: '/site/customer-reviews' }),
    }),
    getTariffList: build.query<GetTariffListApiResponse, GetTariffListApiArg>({
      query: () => ({ url: '/tariff/list' }),
    }),
    getTeamManagementList: build.query<
      GetTeamManagementListApiResponse,
      GetTeamManagementListApiArg
    >({
      query: (queryArg) => ({
        url: '/team-management/list',
        params: {
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          sort: queryArg.sort,
        },
      }),
    }),
    postTeamManagementAddUser: build.mutation<
      PostTeamManagementAddUserApiResponse,
      PostTeamManagementAddUserApiArg
    >({
      query: (queryArg) => ({
        url: '/team-management/add-user',
        method: 'POST',
        body: queryArg.teamAddUserForm,
      }),
    }),
    getTeamManagementEditUser: build.query<
      GetTeamManagementEditUserApiResponse,
      GetTeamManagementEditUserApiArg
    >({
      query: (queryArg) => ({
        url: '/team-management/edit-user',
        params: {
          id: queryArg.id,
        },
      }),
    }),
    postTeamManagementEditUser: build.mutation<
      PostTeamManagementEditUserApiResponse,
      PostTeamManagementEditUserApiArg
    >({
      query: (queryArg) => ({
        url: '/team-management/edit-user',
        method: 'POST',
        body: queryArg.teamEditUserForm,
      }),
    }),
    postTeamManagementUserChangeStatus: build.mutation<
      PostTeamManagementUserChangeStatusApiResponse,
      PostTeamManagementUserChangeStatusApiArg
    >({
      query: (queryArg) => ({
        url: '/team-management/user-change-status',
        method: 'POST',
        body: queryArg.teamUserChangeStatusForm,
      }),
    }),
    postTeamManagementSendInvite: build.mutation<
      PostTeamManagementSendInviteApiResponse,
      PostTeamManagementSendInviteApiArg
    >({
      query: (queryArg) => ({
        url: '/team-management/send-invite',
        method: 'POST',
        body: queryArg.teamSendInviteForm,
      }),
    }),
    getTmInfringementsList: build.query<
      GetTmInfringementsListApiResponse,
      GetTmInfringementsListApiArg
    >({
      query: (queryArg) => ({
        url: '/tm-infringements/list',
        params: {
          project_id: queryArg.projectId,
          trademark_id: queryArg.trademarkId,
          tab: queryArg.tab,
          status: queryArg.status,
          country_id: queryArg.countryId,
          site: queryArg.site,
          case_id: queryArg.caseId,
          engine_id: queryArg.engineId,
          only_registered: queryArg.onlyRegistered,
          show_whitelisted: queryArg.showWhitelisted,
          ids: queryArg.ids,
          page: queryArg.page,
          'per-page': queryArg['per-page'],
          sort: queryArg.sort,
          export: queryArg['export'],
          exportColumns: queryArg.exportColumns,
          date: queryArg.date,
        },
      }),
    }),
    getTmInfringementsCounter: build.query<
      GetTmInfringementsCounterApiResponse,
      GetTmInfringementsCounterApiArg
    >({
      query: (queryArg) => ({
        url: '/tm-infringements/counter',
        params: {
          project_id: queryArg.projectId,
          trademark_id: queryArg.trademarkId,
          country_id: queryArg.countryId,
          site: queryArg.site,
          case_id: queryArg.caseId,
          engine_id: queryArg.engineId,
          only_registered: queryArg.onlyRegistered,
          show_whitelisted: queryArg.showWhitelisted,
          date: queryArg.date,
        },
      }),
    }),
    getTmInfringementsDomainSummary: build.query<
      GetTmInfringementsDomainSummaryApiResponse,
      GetTmInfringementsDomainSummaryApiArg
    >({
      query: (queryArg) => ({
        url: '/tm-infringements/domain-summary',
        params: {
          project_id: queryArg.projectId,
          domain: queryArg.domain,
          country_id: queryArg.countryId,
        },
      }),
    }),
    getTmInfringementsSuccessReport: build.query<
      GetTmInfringementsSuccessReportApiResponse,
      GetTmInfringementsSuccessReportApiArg
    >({
      query: (queryArg) => ({
        url: '/tm-infringements/success-report',
        params: {
          project_id: queryArg.projectId,
          infringement_id: queryArg.infringementId,
        },
      }),
    }),
    getTmInfringementsHistory: build.query<
      GetTmInfringementsHistoryApiResponse,
      GetTmInfringementsHistoryApiArg
    >({
      query: (queryArg) => ({
        url: '/tm-infringements/history',
        params: {
          project_id: queryArg.projectId,
          infringement_id: queryArg.infringementId,
        },
      }),
    }),
    getTmInfringementsViewReply: build.query<
      GetTmInfringementsViewReplyApiResponse,
      GetTmInfringementsViewReplyApiArg
    >({
      query: (queryArg) => ({
        url: '/tm-infringements/view-reply',
        params: {
          project_id: queryArg.projectId,
          case_id: queryArg.caseId,
        },
      }),
    }),
    postTmInfringementsWhitelist: build.mutation<
      PostTmInfringementsWhitelistApiResponse,
      PostTmInfringementsWhitelistApiArg
    >({
      query: (queryArg) => ({
        url: '/tm-infringements/whitelist',
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    postTmInfringementsSubmit: build.mutation<
      PostTmInfringementsSubmitApiResponse,
      PostTmInfringementsSubmitApiArg
    >({
      query: (queryArg) => ({
        url: '/tm-infringements/submit',
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    postTmInfringementsResubmit: build.mutation<
      PostTmInfringementsResubmitApiResponse,
      PostTmInfringementsResubmitApiArg
    >({
      query: (queryArg) => ({
        url: '/tm-infringements/resubmit',
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    getTrademarkList: build.query<GetTrademarkListApiResponse, GetTrademarkListApiArg>({
      query: (queryArg) => ({
        url: '/trademark/list',
        params: {
          project_id: queryArg.projectId,
        },
      }),
    }),
    getTrademarkCard: build.query<GetTrademarkCardApiResponse, GetTrademarkCardApiArg>({
      query: (queryArg) => ({
        url: '/trademark/card',
        params: {
          project_id: queryArg.projectId,
          trademark_id: queryArg.trademarkId,
        },
      }),
    }),
    postTrademarkCreate: build.mutation<PostTrademarkCreateApiResponse, PostTrademarkCreateApiArg>({
      query: (queryArg) => ({ url: '/trademark/create', method: 'POST', body: queryArg.body }),
    }),
    postTrademarkUpdate: build.mutation<PostTrademarkUpdateApiResponse, PostTrademarkUpdateApiArg>({
      query: (queryArg) => ({ url: '/trademark/update', method: 'POST', body: queryArg.body }),
    }),
    postTrademarkUploadLetter: build.mutation<
      PostTrademarkUploadLetterApiResponse,
      PostTrademarkUploadLetterApiArg
    >({
      query: (queryArg) => ({
        url: '/trademark/upload-letter',
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    postTrademarkRegistrationAdd: build.mutation<
      PostTrademarkRegistrationAddApiResponse,
      PostTrademarkRegistrationAddApiArg
    >({
      query: (queryArg) => ({
        url: '/trademark/registration-add',
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    postTrademarkRegistrationUpdate: build.mutation<
      PostTrademarkRegistrationUpdateApiResponse,
      PostTrademarkRegistrationUpdateApiArg
    >({
      query: (queryArg) => ({
        url: '/trademark/registration-update',
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    postTrademarkRegistrationDelete: build.mutation<
      PostTrademarkRegistrationDeleteApiResponse,
      PostTrademarkRegistrationDeleteApiArg
    >({
      query: (queryArg) => ({
        url: '/trademark/registration-delete',
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    postTrademarkArchive: build.mutation<
      PostTrademarkArchiveApiResponse,
      PostTrademarkArchiveApiArg
    >({
      query: (queryArg) => ({ url: '/trademark/archive', method: 'POST', body: queryArg.body }),
    }),
    postTrademarkActivate: build.mutation<
      PostTrademarkActivateApiResponse,
      PostTrademarkActivateApiArg
    >({
      query: (queryArg) => ({ url: '/trademark/activate', method: 'POST', body: queryArg.body }),
    }),
    postUserRequestChangeTariff: build.mutation<
      PostUserRequestChangeTariffApiResponse,
      PostUserRequestChangeTariffApiArg
    >({
      query: (queryArg) => ({
        url: '/user/request-change-tariff',
        method: 'POST',
        body: queryArg.requestChangeTariffForm,
      }),
    }),
    getUserCurrentTariffDetails: build.query<
      GetUserCurrentTariffDetailsApiResponse,
      GetUserCurrentTariffDetailsApiArg
    >({
      query: () => ({ url: '/user/current-tariff-details' }),
    }),
    postUserSendFeedback: build.mutation<
      PostUserSendFeedbackApiResponse,
      PostUserSendFeedbackApiArg
    >({
      query: (queryArg) => ({
        url: '/user/send-feedback',
        method: 'POST',
        body: queryArg.sendFeedbackForm,
      }),
    }),
    postUserGetStripePortalLink: build.mutation<
      PostUserGetStripePortalLinkApiResponse,
      PostUserGetStripePortalLinkApiArg
    >({
      query: () => ({ url: '/user/get-stripe-portal-link', method: 'POST' }),
    }),
    postUserRequestChangeReferralTerms: build.mutation<
      PostUserRequestChangeReferralTermsApiResponse,
      PostUserRequestChangeReferralTermsApiArg
    >({
      query: () => ({ url: '/user/request-change-referral-terms', method: 'POST' }),
    }),
    postUserConfirmContact: build.mutation<
      PostUserConfirmContactApiResponse,
      PostUserConfirmContactApiArg
    >({
      query: (queryArg) => ({
        url: '/user/confirm-contact',
        method: 'POST',
        body: queryArg.confirmContactForm,
      }),
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as api }
export type GetAdOverviewAdsApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: AdOverviewAd[]
    allow_decloak?: boolean
  }
}
export type GetAdOverviewAdsApiArg = {
  projectId: number
  /** Comma-separated list of country IDs */
  countryId?: number[]
  siteId?: number
  /** Comma-separated list of domains */
  site?: string[]
  /** search query */
  search?: string
  /** Comma-separated list of search engine IDs */
  engineId?: number[]
  /** Comma-separated list of city IDs */
  cityId?: number[]
  /** Comma-separated list of browser IDs */
  browserId?: number[]
  osId?: number
  isDecloak?: boolean
  group?: boolean
  isShoppingAds?: boolean
  isTop?: boolean
  /** Comma-separated list of policies (rows matching any of them) */
  policy?: (
    | 'brand_bidding'
    | 'trademark_abuse'
    | 'trademark_abuse_url'
    | 'non_compliant_affiliates'
    | 'ad_hijacking'
    | 'coupon_sites'
  )[]
  /** Comma-separated list of advertiser names (substring match per value) */
  advertiserName?: string[]
  /** Comma-separated list of advertiser IDs from /filter/advertiser-names */
  advertiserId?: string[]
  /** Comma-separated list of affiliate names */
  affiliate?: string[]
  /** Comma-separated list of affiliate IDs from /filter/affiliates */
  affiliateId?: number[]
  /** Filter names applied as exclusion (NOT) instead of inclusion. Supported: country_id, engine_id, city_id, browser_id, os_id, site, site_id, advertiser_name, advertiser_id, search, policy, affiliate, affiliate_id */
  reversedFilters?: string[]
  /** page number */
  page?: number
  /** rows per page */
  'per-page'?: number
  /** sort order, prefix (-) for reverse */
  sort?: string
  /** export as file */
  export?: 'csv' | 'xlsx' | 'fast_xlsx'
  /** comma separated list; `exportColumns[]=a&exportColumns[]=b` is accepted too */
  exportColumns?: string[]
  date?: string
}
export type GetAdOverviewAffiliatesApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: AdOverviewAffiliate[]
  }
}
export type GetAdOverviewAffiliatesApiArg = {
  projectId: number
  countryId?: number
  siteId?: number
  site?: string
  /** search query */
  search?: string
  engineId?: number
  cityId?: number
  browserId?: number
  osId?: number
  isHidden?: boolean
  affiliate?: string
  /** Comma-separated list of policies (rows matching any of them) */
  policy?: (
    | 'brand_bidding'
    | 'trademark_abuse'
    | 'trademark_abuse_url'
    | 'non_compliant_affiliates'
    | 'ad_hijacking'
    | 'coupon_sites'
  )[]
  /** Filter names applied as exclusion (NOT) instead of inclusion. Supported: policy */
  reversedFilters?: string[]
  /** page number */
  page?: number
  /** rows per page */
  'per-page'?: number
  /** sort order, prefix (-) for reverse */
  sort?: string
  /** export as file */
  export?: 'csv' | 'xlsx' | 'fast_xlsx'
  /** comma separated list; `exportColumns[]=a&exportColumns[]=b` is accepted too */
  exportColumns?: string[]
  date?: string
}
export type GetAdOverviewAffiliatesAdsApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: AdOverviewAffiliateAd[]
  }
}
export type GetAdOverviewAffiliatesAdsApiArg = {
  publisherId: number
  projectId: number
  countryId?: number
  siteId?: number
  site?: string
  /** search query */
  search?: string
  engineId?: number
  cityId?: number
  browserId?: number
  osId?: number
  isTop?: boolean
  /** Comma-separated list of policies (rows matching any of them) */
  policy?: (
    | 'brand_bidding'
    | 'trademark_abuse'
    | 'trademark_abuse_url'
    | 'non_compliant_affiliates'
    | 'ad_hijacking'
    | 'coupon_sites'
  )[]
  /** Filter names applied as exclusion (NOT) instead of inclusion. Supported: policy */
  reversedFilters?: string[]
  /** page number */
  page?: number
  /** rows per page */
  'per-page'?: number
  /** sort order, prefix (-) for reverse */
  sort?: string
  /** export as file */
  export?: 'csv' | 'xlsx' | 'fast_xlsx'
  /** comma separated list; `exportColumns[]=a&exportColumns[]=b` is accepted too */
  exportColumns?: string[]
  date?: string
}
export type GetAdOverviewPublisherApiResponse = /** status 200 Ok */ Success & {
  data?: Publisher
}
export type GetAdOverviewPublisherApiArg = {
  id: number
}
export type PostAdOverviewPublisherApiResponse = /** status 200 Ok */ Success & {
  data?: Publisher
}
export type PostAdOverviewPublisherApiArg = {
  body: {
    id: number
    name?: string
    comment?: string
  }
}
export type PostAdOverviewHideAffiliateApiResponse = /** status 200 Ok */ Success & {
  data?: Publisher
}
export type PostAdOverviewHideAffiliateApiArg = {
  body: {
    id: number
    is_hidden?: false | true
  }
}
export type GetAdminVirtualUsersApiResponse = /** status 200 Ok */ Success & {
  data?: {
    /** user_id => user */
    users?: {
      [key: string]: VirtualUser
    }
  }
}
export type GetAdminVirtualUsersApiArg = void
export type PostAdminVirtualLoginApiResponse = /** status 200 Ok */ Success
export type PostAdminVirtualLoginApiArg = {
  /** Id пользователя */
  userId: number
}
export type GetAdvertiserReportsAllAdvertisersApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: AdvertiserReportsAllAdvertisersItems[]
    allow_decloak?: boolean | null
    tab_count?: AllAdvertisersTabCounters
  }
}
export type GetAdvertiserReportsAllAdvertisersApiArg = {
  /** page number */
  page?: number
  /** rows per page */
  'per-page'?: number
  /** sort order, prefix (-) for reverse */
  sort?: string
  /** export as file */
  export?: 'csv' | 'xlsx' | 'fast_xlsx'
  /** comma separated list; `exportColumns[]=a&exportColumns[]=b` is accepted too */
  exportColumns?: string[]
  date?: string
  projectId: number
  policy?:
    | 'brand_bidding'
    | 'trademark_abuse'
    | 'trademark_abuse_url'
    | 'ad_hijacking'
    | 'non_compliant_affiliates'
    | 'coupon_sites'
  /** Comma-separated list of country IDs */
  countryId?: number[]
  /** Comma-separated list of domains */
  site?: string[]
  /** Comma-separated list of affiliate names */
  affiliate?: string[]
  /** Comma-separated list of affiliate IDs */
  affiliateId?: number[]
  /** Comma-separated list of browser IDs */
  browserId?: number[]
  deviceId?: number
  /** Comma-separated list of search engine IDs */
  engineId?: number[]
  /** Comma-separated list of keywords */
  keyword?: string[]
  /** Comma-separated list of keyword IDs from /filter/keywords */
  keywordId?: number[]
  showHidden?: boolean
  status?: 'unprocessed' | 'in_process' | 'completed'
  showAffiliates?: boolean
  showShoppingAds?: boolean
  isDecloak?: boolean
  isTop?: boolean
  /** Comma-separated list of tag IDs */
  tagIds?: number[]
  /** Comma-separated list of advertiser names */
  advertiserName?: string[]
  /** Comma-separated list of advertiser IDs from /filter/advertiser-names */
  advertiserId?: string[]
  /** Filter names applied as exclusion (NOT) instead of inclusion. Supported: country_id, engine_id, browser_id, device_id, site, keyword, keyword_id, advertiser_name, advertiser_id, status, affiliate, affiliate_id, tag_ids */
  reversedFilters?: string[]
}
export type GetAdvertiserReportsOrganicApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: AdvertiserReportsOrganicItems[]
  }
}
export type GetAdvertiserReportsOrganicApiArg = {
  /** page number */
  page?: number
  /** rows per page */
  'per-page'?: number
  /** sort order, prefix (-) for reverse */
  sort?: string
  /** export as file */
  export?: 'csv' | 'xlsx' | 'fast_xlsx'
  /** comma separated list; `exportColumns[]=a&exportColumns[]=b` is accepted too */
  exportColumns?: string[]
  date?: string
  projectId: number
  countryId?: number
  engineId?: number
  /** Comma-separated list of domains */
  site?: string[]
  /** Comma-separated list of policies (rows matching any of them) */
  policy?: ('trademark_abuse' | 'trademark_abuse_url' | 'ad_hijacking')[]
  /** Comma-separated list of keywords */
  keyword?: string[]
  /** Comma-separated list of keyword IDs from /filter/keywords */
  keywordId?: number[]
  /** Comma-separated list of affiliate names */
  affiliate?: string[]
  /** Comma-separated list of affiliate IDs from /filter/affiliates */
  affiliateId?: number[]
  showAffiliates?: boolean
  showHidden?: boolean
  /** Comma-separated list of tag IDs */
  tagIds?: number[]
  hasBrand?: boolean
  /** Filter names applied as exclusion (NOT) instead of inclusion. Supported: country_id, engine_id, site, keyword, keyword_id, affiliate, affiliate_id, tag_ids, policy */
  reversedFilters?: string[]
}
export type PostAdvertiserReportsSiteSettingsApiResponse = /** status 200 Ok */ Success & {
  data?: SiteSettings
}
export type PostAdvertiserReportsSiteSettingsApiArg = {
  body: {
    project_id: number
    domain: string
    is_hide?: 0 | 1
    is_affiliate?: 0 | 1
    name?: string
    comment?: string
    status?: 'unprocessed' | 'in_process' | 'completed'
  }
}
export type PostAdvertiserReportsDecloakSettingsApiResponse = /** status 200 Ok */ Success & {
  data?: DecloakSettings
}
export type PostAdvertiserReportsDecloakSettingsApiArg = {
  body: {
    project_id: number
    domain: string
    is_decloak?: 0 | 1
  }
}
export type GetAffiliateGetApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: AffiliateListItem[]
  }
}
export type GetAffiliateGetApiArg = {
  id: number
  projectId: number
  /** page number */
  page?: number
  /** rows per page */
  'per-page'?: number
  /** sort order, prefix (-) for reverse */
  sort?: string
  date?: string
}
export type GetAffiliateLastAdApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: AffiliateLastAd[]
  }
}
export type GetAffiliateLastAdApiArg = {
  /** Affiliate ID */
  id: number
  /** Project Id */
  projectId: number
  /** Comma-separated list of country IDs */
  countryId?: number[]
  /** Comma-separated list of search engine IDs */
  engineId?: number[]
  /** Comma-separated list of city IDs */
  cityId?: number[]
  /** Comma-separated list of browser IDs */
  browserId?: number[]
  /** OS Id */
  osId?: number
  /** Advertiser (exact site domain) */
  site?: string
  /** Keyword (exact match) */
  keyword?: string
  /** Comma-separated list of advertiser names (substring match per value) */
  advertiserName?: string[]
  /** Comma-separated list of advertiser IDs from /filter/advertiser-names */
  advertiserId?: string[]
  /** Filter names applied as exclusion (NOT) instead of inclusion. Supported: country_id, engine_id, city_id, browser_id, os_id, site, keyword, advertiser_name, advertiser_id */
  reversedFilters?: string[]
  /** Date range (e.g., '2024-01-05 - 2024-02-05') */
  date: string
  /** Is hijack */
  isHijack?: boolean
  /** Shopping ads only */
  showShoppingAds?: boolean
  /** Top block ads only */
  isTop?: boolean
  /** Affiliate pub_value */
  affiliate?: string
  /** Link hash */
  linkHash?: string
}
export type PostAffiliateHideApiResponse = /** status 200 Ok */ Success & {
  data?: Affiliate[]
}
export type PostAffiliateHideApiArg = {
  body: {
    /** Affiliate IDs; comma-separated string is also accepted */
    ids?: number[]
    /** Single affiliate ID (alternative to ids) */
    id?: number
    is_hidden?: false | true
  }
}
export type PostAffiliateUpdateApiResponse = /** status 200 Ok */ Success & {
  data?: Affiliate[]
}
export type PostAffiliateUpdateApiArg = {
  body: {
    /** Affiliate IDs; comma-separated string is also accepted */
    ids?: number[]
    /** Single affiliate ID (alternative to ids) */
    id?: number
    /** Selects which fields are applied */
    scenario?: 'form' | 'update_status' | 'update_network' | 'remove_network' | 'hide'
    affiliate_network_id?: number
    status_id?: number
    name?: string
    comment?: string
    email?: string
    is_hidden?: false | true
  }
}
export type PostAffiliateCreateNetworkApiResponse = /** status 200 Ok */ Success
export type PostAffiliateCreateNetworkApiArg = {
  body: {
    affiliate_id?: number
    project_id?: number
    name?: string
  }
}
export type GetAffiliateRuleListApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: AffiliateRuleFilter[]
  }
}
export type GetAffiliateRuleListApiArg = {
  projectId: number
  /** page number */
  page?: number
  /** rows per page */
  'per-page'?: number
  /** sort order, prefix (-) for reverse */
  sort?: string
}
export type PostAffiliateRuleCreateApiResponse =
  /** status 200 affiliate-rule successfully created or updated */ Success & {
    data?: AffiliateRuleForm & {
      run_sync?: boolean
      /** publisher => status, empty when nothing was deleted */
      affiliateStatus?: {
        [key: string]: AffiliateRuleStatus
      }
    }
  }
export type PostAffiliateRuleCreateApiArg = {
  body: {
    /** The current step in the affiliate-rule creation process. */
    scenario: 'first_step' | 'second_step' | 'third_step' | 'create'
    /** Run sync after rule creation */
    run_sync?: boolean
  } & AffiliateRuleForm
}
export type PostAffiliateRuleUpdateApiResponse =
  /** status 200 affiliate-rule successfully updated */ Success & {
    data?: AffiliateRuleForm & {
      run_sync?: boolean
      /** publisher => status, empty when nothing was deleted */
      affiliateStatus?: {
        [key: string]: AffiliateRuleStatus
      }
    }
  }
export type PostAffiliateRuleUpdateApiArg = {
  body: {
    /** Scenario to update */
    scenario: 'update_zones' | 'update_status' | 'update_params'
    /** Run sync after rule update */
    run_sync?: boolean
  } & AffiliateRuleForm
}
export type PostAffiliateRuleRunSyncApiResponse =
  /** status 200 affiliate-rule affiliates successfully queued */ Success
export type PostAffiliateRuleRunSyncApiArg = {
  body: AffiliateRuleForm
}
export type PostAffiliateRuleDeleteAffiliatesApiResponse =
  /** status 200 affiliate-rule affiliates successfully deleted */ Success
export type PostAffiliateRuleDeleteAffiliatesApiArg = {
  body: AffiliateRuleForm
}
export type PostAffiliateRuleCreateCustomZoneApiResponse =
  /** status 200 Custom domain zone successfully created */ Success & {
    /** zone => label */
    data?: {
      [key: string]: string
    }
  }
export type PostAffiliateRuleCreateCustomZoneApiArg = {
  body: {
    /** URL to extract zone from */
    url: string
    /** Project ID */
    project_id: number
  }
}
export type GetComplianceNonCompliantAffiliatesApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    tab_count?: NonCompliantAffiliatesTabCounters
  } & {
    items?: NonCompliantAffiliate[]
  }
}
export type GetComplianceNonCompliantAffiliatesApiArg = {
  projectId: number
  /** Comma-separated list of country IDs */
  countryId?: number[]
  site?: string
  /** Comma-separated list of search engine IDs */
  engineId?: number[]
  /** Comma-separated list of city IDs */
  cityId?: number[]
  /** Comma-separated list of browser IDs */
  browserId?: number[]
  osId?: number
  isHidden?: boolean
  showShoppingAds?: boolean
  isHijack?: boolean
  statusId?: number
  affiliateRuleId?: number
  status?: string
  network?: string
  /** Unspecified = 0 */
  networkId?: number
  /** Comma-separated list of advertiser names (substring match per value) */
  advertiserName?: string[]
  /** Comma-separated list of advertiser IDs from /filter/advertiser-names */
  advertiserId?: string[]
  /** Comma-separated list of affiliate (publisher) names (substring match per value) */
  affiliate?: string[]
  /** Comma-separated list of affiliate IDs from /filter/affiliates */
  affiliateId?: number[]
  /** filter by affiliate ids; comma separated, `aff_ids[]=1&aff_ids[]=2` is accepted too */
  affIds?: number[]
  /** keyword filter (exact match) */
  keyword?: string
  /** Filter names applied as exclusion (NOT) instead of inclusion. Supported: country_id, engine_id, city_id, browser_id, os_id, site, advertiser_name, advertiser_id, affiliate, affiliate_id, keyword, network */
  reversedFilters?: string[]
  /** page number */
  page?: number
  /** rows per page */
  'per-page'?: number
  /** sort order, prefix (-) for reverse */
  sort?: string
  /** export as file */
  export?: 'csv' | 'xlsx' | 'fast_xlsx'
  /** comma separated list; `exportColumns[]=a&exportColumns[]=b` is accepted too */
  exportColumns?: string[]
  date?: string
}
export type PostComplianceSendAbuseMailApiResponse = /** status 200 Ok */ Success
export type PostComplianceSendAbuseMailApiArg = {
  body: {
    /** Sender email from `/compliance/get-email-list` */
    from: string
    /** If there are multiple emails, then pass it separated by `,`. Example: `email1@mail.com, email2@mail.com` */
    to: string
    /** Email that will be added to carbon copy */
    carbonCopy?: string
    /** Subject of the email */
    subject: string
    /** Supports HTML markup, example: `This is the <b>body</b> of the abuse email.` */
    body: string
    /** If `true`, then project network will be updated. Needs params `network_id` and `project_id` in `filterData` */
    rememberForNetwork?: boolean
    /** If `true`, then affiliate's email will be updated. Needs param `affiliate_id` in `filterData` */
    rememberForAffiliate?: boolean
    /** If `true`, then affiliate's status will be updated. Needs param `affiliate_id` in `filterData` */
    markAffiliate?: boolean
    filterData: FilterData
  }
}
export type GetComplianceGetEmailListApiResponse =
  /** status 200 Successful response with default abuse email address */ Success & {
    data?: string[]
  }
export type GetComplianceGetEmailListApiArg = void
export type GetComplianceLastSendEmailApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: LastSendEmail[]
  }
}
export type GetComplianceLastSendEmailApiArg = {
  projectId: number
  affiliateId: number
  networkId: number
}
export type GetDecloakFilterApiResponse = /** status 200 Ok */ Success & {
  data?: DecloakTimeFilter
}
export type GetDecloakFilterApiArg = {
  domain?: string
  countryId?: number
  date?: string
}
export type GetDecloakCompareScreenshotsApiResponse = /** status 200 Ok */ Success & {
  data?: DecloakCompareScreenshots
}
export type GetDecloakCompareScreenshotsApiArg = {
  id: string
}
export type GetDecloakCompareHtmlApiResponse = /** status 200 Ok */ Success & {
  data?: DecloakCompareHtml
}
export type GetDecloakCompareHtmlApiArg = {
  id: string
}
export type GetDecloakCompareLinksApiResponse = /** status 200 Ok */ Success & {
  data?: DecloakCompareLinks
}
export type GetDecloakCompareLinksApiArg = {
  id: string
}
export type GetDecloakAdApiResponse = /** status 200 Ok */ Success & {
  data?: DecloakAd
}
export type GetDecloakAdApiArg = {
  id: string
}
export type GetDecloakLiveApiResponse = /** status 200 Ok */ Success & {
  data?: DecloakLive
}
export type GetDecloakLiveApiArg = {
  deviceId: number
  countryId: number
  site: string
  exludeIds?: string
}
export type GetDecloakCountryApiResponse = /** status 200 Ok */ Success & {
  data?: {
    id?: number
    name?: string
  }[]
}
export type GetDecloakCountryApiArg = void
export type GetDomainTagListApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: DomainTag[]
  }
}
export type GetDomainTagListApiArg = {
  projectId: number
}
export type PostDomainTagCreateApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: DomainTag[]
  }
}
export type PostDomainTagCreateApiArg = {
  body: {
    project_id: number
    name: string
    color?: 'purple' | 'red' | 'green' | 'grey'
  }
}
export type PostDomainTagUpdateApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: DomainTag[]
  }
}
export type PostDomainTagUpdateApiArg = {
  body: {
    id: number
    project_id: number
    name?: string
    color?: 'purple' | 'red' | 'green' | 'grey'
  }
}
export type PostDomainTagDeleteApiResponse = /** status 200 Ok */ Success
export type PostDomainTagDeleteApiArg = {
  body: {
    id: number
    project_id: number
  }
}
export type PostDomainTagAssignApiResponse = /** status 200 Ok */ Success
export type PostDomainTagAssignApiArg = {
  body: {
    domain_tag_id: number
    domain: string
    project_id: number
  }
}
export type PostDomainTagUnassignApiResponse = /** status 200 Ok */ Success
export type PostDomainTagUnassignApiArg = {
  body: {
    domain_tag_id: number
    domain: string
    project_id: number
  }
}
export type GetDomainTagByDomainApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: DomainTagByDomain[]
  }
}
export type GetDomainTagByDomainApiArg = {
  projectId: number
  domain: string
}
export type GetExportReportsAllAdvertisersApiResponse = unknown
export type GetExportReportsAllAdvertisersApiArg = {
  /** Export format (e.g., 'xlsx') */
  export?: 'xlsx' | 'csv'
  /** PHP array syntax: exportColumns[]=a&exportColumns[]=b. Columns to export. If contains `latest_examples`, page with latest examples will be added in report (xlsx only) */
  exportColumns?: string[]
  /** Page number */
  page?: number
  /** Items per page */
  'per-page'?: number
  date?: string
  projectId: number
  policy?:
    | 'brand_bidding'
    | 'trademark_abuse'
    | 'trademark_abuse_url'
    | 'ad_hijacking'
    | 'non_compliant_affiliates'
    | 'coupon_sites'
  /** Comma-separated list of country IDs */
  countryId?: number[]
  /** Comma-separated list of domains */
  site?: string[]
  /** Comma-separated list of affiliate names */
  affiliate?: string[]
  /** Comma-separated list of affiliate IDs */
  affiliateId?: number[]
  /** Comma-separated list of browser IDs */
  browserId?: number[]
  deviceId?: number
  /** Comma-separated list of search engine IDs */
  engineId?: number[]
  /** Comma-separated list of keywords */
  keyword?: string[]
  /** Comma-separated list of keyword IDs from /filter/keywords */
  keywordId?: number[]
  showHidden?: boolean
  status?: 'unprocessed' | 'in_process' | 'completed'
  showAffiliates?: boolean
  showShoppingAds?: boolean
  isDecloak?: boolean
  isTop?: boolean
  /** Comma-separated list of tag IDs */
  tagIds?: number[]
  /** Comma-separated list of advertiser names */
  advertiserName?: string[]
  /** Comma-separated list of advertiser IDs from /filter/advertiser-names */
  advertiserId?: string[]
  /** Filter names applied as exclusion (NOT) instead of inclusion. Supported: country_id, engine_id, browser_id, device_id, site, keyword, keyword_id, advertiser_name, advertiser_id, status, affiliate, affiliate_id, tag_ids */
  reversedFilters?: string[]
}
export type GetExportReportsDomainAdvertisersApiResponse = unknown
export type GetExportReportsDomainAdvertisersApiArg = {
  /** ID of the project */
  projectId: number
  /** Exact domain of the expanded row */
  site: string
  /** Date range (e.g., '2024-01-05 - 2024-02-05') */
  date?: string
  /** Comma-separated list of country IDs */
  countryId?: number[]
  /** Comma-separated list of search engine IDs */
  engineId?: number[]
  /** Comma-separated list of browser IDs */
  browserId?: number[]
  /** ID of the device */
  deviceId?: number
  /** Comma-separated list of keywords */
  keyword?: string[]
  /** Comma-separated list of keyword IDs from /filter/keywords */
  keywordId?: number[]
  /** Comma-separated list of affiliate names */
  affiliate?: string[]
  /** Comma-separated list of affiliate IDs from /filter/affiliates */
  affiliateId?: number[]
  /** Comma-separated list of advertiser name substrings */
  advertiserName?: string[]
  /** Comma-separated list of advertiser IDs from /filter/advertiser-names */
  advertiserId?: string[]
  /** Policy tab of the Paid grid */
  policy?:
    | 'brand_bidding'
    | 'trademark_abuse'
    | 'trademark_abuse_url'
    | 'ad_hijacking'
    | 'non_compliant_affiliates'
    | 'coupon_sites'
  /** Only shopping ads */
  showShoppingAds?: boolean
  /** Filter names applied as exclusion (NOT) instead of inclusion. Supported: country_id, engine_id, browser_id, device_id, keyword, keyword_id, affiliate, affiliate_id, advertiser_name, advertiser_id */
  reversedFilters?: string[]
  /** Export format */
  export: 'xlsx' | 'csv'
  /** PHP array syntax: exportColumns[]=a&exportColumns[]=b. Columns to export:advertiser, affiliate_id, ads_count, countries, search_engine, last_found */
  exportColumns?: string[]
}
export type GetExportReportsAffiliatesApiResponse = unknown
export type GetExportReportsAffiliatesApiArg = {
  /** ID of the browser */
  browserId?: number
  /** ID of the country */
  countryId?: number
  /** Date range (e.g., '2024-01-05 - 2024-02-05') */
  date?: string
  /** ID of the search engine */
  engineId?: number
  /** Export format (e.g., 'xlsx') */
  export?: 'xlsx' | 'csv'
  /** PHP array syntax: exportColumns[]=a&exportColumns[]=b. Columns to export */
  exportColumns?: string[]
  /** Decloak status */
  isDecloak?: boolean
  /** Page number */
  page?: number
  /** Items per page */
  'per-page'?: number
  /** Policy type */
  policy?: 'brand_bidding' | 'trademark_abuse' | 'trademark_abuse_url' | 'ad_hijacking'
  /** ID of the project */
  projectId?: number
  /** Show affiliates */
  showAffiliates?: boolean
  /** Show hidden */
  showHidden?: boolean
  /** Status */
  status?: string
}
export type GetExportReportsAffiliateLastAdApiResponse = unknown
export type GetExportReportsAffiliateLastAdApiArg = {
  /** Affiliate id */
  id: number
  /** Project id */
  projectId: number
  /** Comma-separated list of country IDs */
  countryId?: number[]
  /** Comma-separated list of search engine IDs */
  engineId?: number[]
  /** Comma-separated list of city IDs */
  cityId?: number[]
  /** Comma-separated list of browser IDs */
  browserId?: number[]
  /** OS id */
  osId?: number
  /** Advertiser (exact site domain) */
  site?: string
  /** Keyword (exact match) */
  keyword?: string
  /** Comma-separated list of advertiser names (substring match per value) */
  advertiserName?: string[]
  /** Comma-separated list of advertiser IDs from /filter/advertiser-names */
  advertiserId?: string[]
  /** Filter names applied as exclusion (NOT) instead of inclusion. Supported: country_id, engine_id, city_id, browser_id, os_id, site, keyword, advertiser_name, advertiser_id */
  reversedFilters?: string[]
  /** Date */
  date: string
  /** Is hijack flag */
  isHijack?: boolean
  /** Shopping ads only */
  showShoppingAds?: boolean
  /** Top block ads only */
  isTop?: boolean
  /** Affiliate (publisher) */
  affiliate?: string
}
export type GetExportReportsAffiliateAdsApiResponse = unknown
export type GetExportReportsAffiliateAdsApiArg = {
  /** ID of the project */
  projectId: number
  /** E.g. 'utm_source=leadgid&wmid=79146 */
  affiliate: string
  /** Comma-separated list of country IDs */
  countryId?: number[]
  /** Comma-separated list of domains */
  site?: string[]
  /** Comma-separated list of browser IDs */
  browserId?: number[]
  /** Comma-separated list of search engine IDs */
  engineId?: number[]
  /** Comma-separated list of city IDs */
  cityId?: number[]
  /** Is hijack */
  isHijack?: boolean
  /** Comma-separated list of advertiser names (substring match per value) */
  advertiserName?: string[]
  /** Comma-separated list of affiliate IDs from /filter/affiliates */
  affiliateId?: number[]
  /** Comma-separated list of advertiser IDs from /filter/advertiser-names */
  advertiserId?: string[]
  /** Filter names applied as exclusion (NOT) instead of inclusion. Supported: country_id, engine_id, city_id, browser_id, os_id, site, site_id, advertiser_name, advertiser_id, search, policy, affiliate, affiliate_id */
  reversedFilters?: string[]
  /** Export format (e.g., 'xlsx') */
  export: 'xlsx' | 'csv'
  date?: string
}
export type GetExportReportsNonCompliantAffiliatesApiResponse = unknown
export type GetExportReportsNonCompliantAffiliatesApiArg = {
  /** ID of the project */
  projectId: number
  /** Date range (e.g., '2024-01-05 - 2024-02-05') */
  date: string
  /** Status ID of the affiliate */
  statusId?: number
  /** ID of the network */
  networkId?: number
  /** Show hidden affiliates */
  isHidden?: boolean
  /** Show ad hijackers only */
  isHijack?: boolean
  /** Affiliate IDs (comma-separated or repeated param) */
  affIds?: number[]
  /** Advertiser (site domain) */
  site?: string
  /** Comma-separated list of affiliate name substrings */
  affiliate?: string[]
  /** Comma-separated list of affiliate IDs from /filter/affiliates */
  affiliateId?: number[]
  /** ID of the affiliate rule */
  affiliateRuleId?: number
  /** Comma-separated list of advertiser name substrings */
  advertiserName?: string[]
  /** Comma-separated list of advertiser IDs from /filter/advertiser-names */
  advertiserId?: string[]
  /** Keyword */
  keyword?: string
  /** Affiliate network name substring */
  network?: string
  /** Comma-separated list of browser IDs */
  browserId?: number[]
  /** Comma-separated list of country IDs */
  countryId?: number[]
  /** Comma-separated list of search engine IDs */
  engineId?: number[]
  /** Comma-separated list of city IDs */
  cityId?: number[]
  /** ID of the OS */
  osId?: number
  /** Only shopping ads */
  showShoppingAds?: boolean
  /** Filter names applied as exclusion (NOT) instead of inclusion. Supported: country_id, engine_id, city_id, browser_id, os_id, site, keyword, advertiser_name, advertiser_id, affiliate, affiliate_id, network */
  reversedFilters?: string[]
  /** Export format (e.g., 'xlsx') */
  export?: 'xlsx' | 'csv'
  /** PHP array syntax: exportColumns[]=a&exportColumns[]=b. Columns to export. If contains `latest_examples`, page with latest examples will be added in report (same filters as the affiliates sheet) */
  exportColumns?: string[]
  /** Page number */
  page?: number
  /** Items per page */
  'per-page'?: number
}
export type GetFeaturesDecloakApiResponse = /** status 200 Ok */ Success & {
  data?: DecloakResult
}
export type GetFeaturesDecloakApiArg = {
  deviceId: number
  countryId: number
  site: string
  cache?: boolean
  notExclusive?: boolean
  workerType?: string
}
export type GetFilterProjectsApiResponse = /** status 200 Ok */ Success & {
  data?: FilterProject[]
}
export type GetFilterProjectsApiArg = {
  /** If true, endpoint will return projects in all statuses (archive, pause,active), if not passed then response will contiain only active projects */
  all?: boolean
}
export type GetFilterCountryApiResponse = /** status 200 Ok */ Success & {
  data?: FilterCountry[]
}
export type GetFilterCountryApiArg = {
  /** ID of the project */
  projectId?: number
  /** user's countries at the top of the list */
  projectsCountriesPriority?: boolean
  /** `IGNORES OTHER PARAMS` returns countries only in projects that the user has access to */
  onlyActiveProjects?: boolean
  /** requires `project_id`. Adds `keywords_state` (active|deleted|never) to each country to render Zero/Empty state for Paid & Organic results */
  withKeywordsState?: boolean
}
export type GetFilterAdvertiserDomainsApiResponse = /** status 200 Ok */ Success & {
  data?: AdvertiserDomains[]
}
export type GetFilterAdvertiserDomainsApiArg = {
  search?: string
  projectId: number
  seo?: boolean
  date?: string
}
export type GetFilterAdvertiserLandingApiResponse = /** status 200 Ok */ Success & {
  data?: AdvertiserLandings[]
}
export type GetFilterAdvertiserLandingApiArg = {
  search?: string
  projectId: number
  date?: string
}
export type GetFilterCityApiResponse = /** status 200 Ok */ Success & {
  data?: IdName[]
}
export type GetFilterCityApiArg = {
  projectId?: number
  /** Comma-separated list of country IDs */
  countryId?: number[]
  all?: boolean
}
export type GetFilterEngineApiResponse = /** status 200 Ok */ Success & {
  data?: FilterEngine[]
}
export type GetFilterEngineApiArg = {
  projectId?: number
}
export type GetFilterEngineLiveSearchApiResponse = /** status 200 Ok */ Success & {
  data?: IdName[]
}
export type GetFilterEngineLiveSearchApiArg = void
export type GetFilterBrowserApiResponse = /** status 200 Ok */ Success & {
  data?: IdName[]
}
export type GetFilterBrowserApiArg = void
export type GetFilterDevicesApiResponse = /** status 200 Ok */ Success & {
  data?: IdName[]
}
export type GetFilterDevicesApiArg = void
export type GetFilterDeviceTypesApiResponse = /** status 200 Ok */ Success & {
  data?: IdName[]
}
export type GetFilterDeviceTypesApiArg = void
export type GetFilterAdsTypesApiResponse = /** status 200 Ok */ Success & {
  /** ads type id => label */
  data?: {
    paid: string
    seo: string
    all: string
  }
}
export type GetFilterAdsTypesApiArg = void
export type GetFilterKeywordsApiResponse = /** status 200 Ok */ Success & {
  data?: IdName[]
}
export type GetFilterKeywordsApiArg = {
  projectId: number
  countryId?: number
  search?: string
}
export type GetFilterAffiliatesApiResponse = /** status 200 Ok */ Success & {
  data?: FilterAffiliate[]
}
export type GetFilterAffiliatesApiArg = {
  date: string
  projectId: number
  isSeo: boolean
  siteId?: number
  search?: string
}
export type GetFilterPolicyApiResponse = /** status 200 Ok */ Success & {
  data?: {
    [key: string]: string
  }
}
export type GetFilterPolicyApiArg = void
export type GetFilterOwnDomainsApiResponse = /** status 200 Ok */ Success & {
  data?: string[]
}
export type GetFilterOwnDomainsApiArg = {
  projectId: number
}
export type GetFilterAffiliateStatusApiResponse = /** status 200 Ok */ Success & {
  data?: {
    [key: string]: string
  }
}
export type GetFilterAffiliateStatusApiArg = {
  all?: boolean
}
export type GetFilterNetworkApiResponse = /** status 200 Ok */ Success & {
  data?: NetworkFilter[]
}
export type GetFilterNetworkApiArg = {
  projectId: number
}
export type GetFilterProjectStatusApiResponse = /** status 200 Ok */ Success & {
  data?: {
    [key: string]: string
  }
}
export type GetFilterProjectStatusApiArg = void
export type GetFilterBrowserLanguageApiResponse = /** status 200 Ok */ Success & {
  data?: FilterBrowserLanguage[]
}
export type GetFilterBrowserLanguageApiArg = {
  countryId: number
}
export type GetFilterCompanyApiResponse = /** status 200 Ok */ Success & {
  data?: IdName[]
}
export type GetFilterCompanyApiArg = void
export type GetFilterCompanyRoleApiResponse = /** status 200 Ok */ Success & {
  data?: {
    [key: string]: string
  }
}
export type GetFilterCompanyRoleApiArg = void
export type GetFilterAssistanceRequestApiResponse = /** status 200 Ok */ Success & {
  data?: {
    [key: string]: string
  }
}
export type GetFilterAssistanceRequestApiArg = void
export type GetFilterSubRolesApiResponse = /** status 200 Ok */ Success & {
  data?: {
    [key: string]: string
  }
}
export type GetFilterSubRolesApiArg = void
export type GetFilterDomainZonesApiResponse = /** status 200 Ok */ Success & {
  data?: {
    [key: string]: string
  }
}
export type GetFilterDomainZonesApiArg = void
export type GetFilterContactMethodApiResponse = /** status 200 Ok */ Success & {
  data?: {
    [key: string]: string
  }
}
export type GetFilterContactMethodApiArg = void
export type GetFilterPayoutStatusApiResponse = /** status 200 Ok */ Success & {
  data?: {
    [key: string]: string
  }
}
export type GetFilterPayoutStatusApiArg = void
export type GetFilterAdvertiserNamesApiResponse = /** status 200 Ok */ Success & {
  data?: AdvertiserNamesFilter[]
}
export type GetFilterAdvertiserNamesApiArg = {
  search?: string
  projectId: number
  date?: string
}
export type GetFilterTrademarkApiResponse = /** status 200 Ok */ Success & {
  data?: {
    id?: number
    name?: string
    status?: 'active' | 'inactive'
  }[]
}
export type GetFilterTrademarkApiArg = {
  projectId: number
}
export type GetFilterCaseIdApiResponse = /** status 200 Ok */ Success & {
  data?: {
    id?: string
    name?: string
  }[]
}
export type GetFilterCaseIdApiArg = {
  projectId: number
  /** defaults to the active trademark */
  trademarkId?: number
  search?: string
}
export type GetFilterTmReplyTypeApiResponse = /** status 200 Ok */ Success & {
  data?: {
    [key: string]: string
  }
}
export type GetFilterTmReplyTypeApiArg = void
export type GetFilterTmInfringementDomainsApiResponse = /** status 200 Ok */ Success & {
  data?: {
    name?: string
  }[]
}
export type GetFilterTmInfringementDomainsApiArg = {
  projectId: number
  /** defaults to the active trademark */
  trademarkId?: number
  search?: string
  tab?: 'to_submit' | 'in_progress' | 'removed'
  /** in_progress tab only */
  status?: 'submitted' | 'accepted' | 'rejected'
  /** Comma-separated list of country IDs */
  countryId?: number[]
  engineId?: number
  /** to_submit tab only */
  onlyRegistered?: boolean
  showWhitelisted?: boolean
  date?: string
}
export type GetFilterAlertTypeApiResponse = /** status 200 Ok */ Success & {
  data?: {
    [key: string]: string
  }
}
export type GetFilterAlertTypeApiArg = void
export type GetFilterNotificationDeliveryModeApiResponse = /** status 200 Ok */ Success & {
  data?: {
    [key: string]: string
  }
}
export type GetFilterNotificationDeliveryModeApiArg = void
export type GetFilterNotificationFrequencyApiResponse = /** status 200 Ok */ Success & {
  data?: {
    [key: string]: string
  }
}
export type GetFilterNotificationFrequencyApiArg = void
export type GetFilterNotificationChannelApiResponse = /** status 200 Ok */ Success & {
  data?: {
    [key: string]: string
  }
}
export type GetFilterNotificationChannelApiArg = void
export type GetFilterWeekdayApiResponse = /** status 200 Ok */ Success & {
  data?: {
    [key: string]: string
  }
}
export type GetFilterWeekdayApiArg = void
export type GetFilterTimezoneApiResponse = /** status 200 Ok */ Success & {
  data?: IanaTimeZoneWithTheCurrentUtcOffset[]
}
export type GetFilterTimezoneApiArg = void
export type GetLanguageComplianceLastCheckApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: LanguageComplianceLastCheck[]
  }
}
export type GetLanguageComplianceLastCheckApiArg = {
  projectId: number
  /** Comma-separated list of country IDs */
  countryId?: number[]
  date: string
  deviceId?: number
  /** Comma-separated list of URLs */
  url?: string[]
  /** Comma-separated list of page IDs (id) from /language-compliance/filter-page */
  urlId?: string[]
  /** Page number */
  page?: number
  /** Items per page */
  'per-page'?: number
  /** Comma-separated list of affiliate names */
  affiliate?: string[]
  /** Comma-separated list of word IDs */
  wordId?: number[]
  showHidden?: boolean
  manualOnly?: boolean
}
export type GetLanguageComplianceInProgressApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: LanguageComplianceInProgress[]
  }
}
export type GetLanguageComplianceInProgressApiArg = {
  projectId: number
  /** Comma-separated list of country IDs */
  countryId?: number[]
  date: string
  deviceId?: number
  /** Comma-separated list of URLs */
  url?: string[]
  /** Comma-separated list of page IDs (id) from /language-compliance/filter-page */
  urlId?: string[]
  /** Page number */
  page?: number
  /** Items per page */
  'per-page'?: number
  /** Comma-separated list of affiliate names */
  affiliate?: string[]
  /** Comma-separated list of word IDs */
  wordId?: number[]
  showHidden?: boolean
  manualOnly?: boolean
}
export type GetLanguageComplianceHistoryApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: LanguageComplianceHistory[]
  }
}
export type GetLanguageComplianceHistoryApiArg = {
  projectId: number
  /** Comma-separated list of country IDs */
  countryId?: number[]
  date: string
  deviceId?: number
  /** Comma-separated list of URLs */
  url?: string[]
  /** Comma-separated list of page IDs (id) from /language-compliance/filter-page */
  urlId?: string[]
  /** Page number */
  page?: number
  /** Items per page */
  'per-page'?: number
  /** Comma-separated list of affiliate names */
  affiliate?: string[]
  /** Comma-separated list of word IDs */
  wordId?: number[]
  showHidden?: boolean
  manualOnly?: boolean
}
export type GetLanguageComplianceCounterApiResponse = /** status 200 Ok */ Success & {
  data?: {
    last_check?: number
    in_progress?: number
    history?: number
  }
}
export type GetLanguageComplianceCounterApiArg = {
  projectId: number
  /** Comma-separated list of country IDs */
  countryId?: number[]
  date: string
  deviceId?: number
  /** Comma-separated list of URLs */
  url?: string[]
  /** Comma-separated list of page IDs (id) from /language-compliance/filter-page */
  urlId?: string[]
  /** Comma-separated list of affiliate names */
  affiliate?: string[]
  /** Comma-separated list of word IDs */
  wordId?: number[]
  showHidden?: boolean
  manualOnly?: boolean
}
export type GetLanguageComplianceHistoryDetailApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: LanguageComplianceHistoryDetail[]
  }
}
export type GetLanguageComplianceHistoryDetailApiArg = {
  projectId: number
  /** Comma-separated list of country IDs */
  countryId?: number[]
  date: string
  deviceId?: number
  /** Comma-separated list of URLs */
  url?: string[]
  /** Comma-separated list of page IDs (id) from /language-compliance/filter-page */
  urlId?: string[]
  /** Page number */
  page?: number
  /** Items per page */
  'per-page'?: number
  /** Comma-separated list of affiliate names */
  affiliate?: string[]
  /** Comma-separated list of word IDs */
  wordId?: number[]
  showHidden?: boolean
  manualOnly?: boolean
}
export type GetLanguageComplianceReportApiResponse = /** status 200 Ok */ Success & {
  data?: LanguageComplianceReport
}
export type GetLanguageComplianceReportApiArg = {
  id: string
}
export type GetLanguageComplianceExportApiResponse = /** status 200 Ok */ Success
export type GetLanguageComplianceExportApiArg = {
  projectId: number
  /** Comma-separated list of country IDs */
  countryId?: number[]
  date: string
  deviceId?: number
  /** Comma-separated list of URLs */
  url?: string[]
  /** Comma-separated list of page IDs (id) from /language-compliance/filter-page */
  urlId?: string[]
  /** Page number */
  page?: number
  /** Items per page */
  'per-page'?: number
  /** Comma-separated list of affiliate names */
  affiliate?: string[]
  /** Comma-separated list of word IDs */
  wordId?: number[]
  showHidden?: boolean
  manualOnly?: boolean
}
export type GetLanguageComplianceFilterProjectApiResponse = /** status 200 Ok */ Success & {
  data?: LanguageComplianceProjectSuggest[]
}
export type GetLanguageComplianceFilterProjectApiArg = void
export type GetLanguageComplianceFilterCountryApiResponse = /** status 200 Ok */ Success & {
  data?: LanguageComplianceCountrySuggest[]
}
export type GetLanguageComplianceFilterCountryApiArg = {
  projectId: number
}
export type GetLanguageComplianceFilterPageApiResponse = /** status 200 Ok */ Success & {
  data?: LanguageCompliancePageSuggest[]
}
export type GetLanguageComplianceFilterPageApiArg = {
  projectId: number
}
export type GetLanguageComplianceFilterAffiliateApiResponse = /** status 200 Ok */ Success & {
  data?: LanguageComplianceAffiliateSuggest[]
}
export type GetLanguageComplianceFilterAffiliateApiArg = {
  projectId: number
}
export type GetLanguageComplianceFilterWordApiResponse = /** status 200 Ok */ Success & {
  data?: LanguageComplianceWordSuggest[]
}
export type GetLanguageComplianceFilterWordApiArg = {
  projectId: number
}
export type PostLanguageComplianceUpdateStateApiResponse = /** status 200 Ok */ Success & {
  data?: boolean
}
export type PostLanguageComplianceUpdateStateApiArg = {
  stateForm: LanguageComplianceUpdateState
}
export type PostN8NSendMessageApiResponse = /** status 200 Ok */ Success & {
  data?: {
    output?: string
  }
}
export type PostN8NSendMessageApiArg = {
  body: {
    /** sessionId */
    sessionId: string
    /** Message */
    message: string
    /** Chat flow, 'support' or 'analysis' */
    flow?: string
  }
}
export type GetNotificationStateApiResponse = /** status 200 Ok */ Success & {
  data?: ProjectNotificationsCard
}
export type GetNotificationStateApiArg = {
  projectId: number
}
export type GetNotificationScheduleApiResponse = /** status 200 Ok */ Success & {
  data?: AlertingScheduleOfOneAlertType
}
export type GetNotificationScheduleApiArg = {
  projectId: number
  type: 'affiliates' | 'tm_infringements'
}
export type PostNotificationSaveScheduleApiResponse = /** status 200 Ok */ Success
export type PostNotificationSaveScheduleApiArg = {
  notificationScheduleForm: AlertingScheduleOfOneAlertType2
}
export type PostNotificationSaveCardApiResponse = /** status 200 Ok */ Success
export type PostNotificationSaveCardApiArg = {
  notificationCardForm: NotificationsCard
}
export type GetProfileInfoApiResponse = /** status 200 Ok */ Success & {
  data?: ProfileForm
}
export type GetProfileInfoApiArg = void
export type PostProfileInfoApiResponse = /** status 200 Ok */ Success & {
  data?: ProfileForm
}
export type PostProfileInfoApiArg = {
  profileForm: ProfileForm
}
export type PostProfileChangeEmailApiResponse = /** status 200 Ok */ Success
export type PostProfileChangeEmailApiArg = {
  changeEmailForm: ChangeEmailForm
}
export type PostProfileChangePasswordApiResponse = /** status 200 Ok */ Success
export type PostProfileChangePasswordApiArg = {
  changePasswordForm: ChangePasswordForm
}
export type PostProfileMenuPositionApiResponse = /** status 200 Ok */ Success & {
  data?: {
    front_menu_position?: 'sidebar' | 'top'
  }
}
export type PostProfileMenuPositionApiArg = {
  body: {
    front_menu_position: 'sidebar' | 'top'
  }
}
export type PostProjectCreateApiResponse =
  /** status 200 Project successfully created or updated */ Success & {
    data?: {
      /** Created Project ID. */
      id?: number
    } & ProjectForm
  }
export type PostProjectCreateApiArg = {
  body: {
    /** The current step in the project creation process. */
    step:
      | 'first'
      | 'second'
      | 'third'
      | 'onboarding_first'
      | 'onboarding_second'
      | 'onboarding_third'
      | 'onboarding_fourth'
      | 'onboarding_fifth'
  } & ProjectForm
}
export type GetProjectListApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: ProjectListRow[]
  }
}
export type GetProjectListApiArg = {
  projectId?: number
  /** Comma-separated project IDs */
  projectIds?: string
  countryId?: number
  status?: 'active' | 'pause' | 'archive'
  /** page number */
  page?: number
  /** rows per page */
  'per-page'?: number
  /** sort order, prefix (-) for reverse */
  sort?: string
}
export type PostProjectUpdateStatusApiResponse = /** status 200 Ok */ Success & {
  data?: {
    id?: number
    name?: string
    status?: string
  }[]
}
export type PostProjectUpdateStatusApiArg = {
  body: {
    /** Project IDs; comma-separated string is also accepted */
    ids?: number[]
    /** Single project ID (alternative to ids) */
    id?: number
    status?: 'active' | 'pause' | 'archive'
  }
}
export type GetProjectInfoApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: ProjectInfoForm[]
  }
}
export type GetProjectInfoApiArg = {
  id: number
}
export type PostProjectUpdateInfoApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: ProjectInfoForm[]
  }
}
export type PostProjectUpdateInfoApiArg = {
  body: {
    id: number
    name: string
  }
}
export type GetProjectMainSettingsApiResponse = /** status 200 Successful response */ Success & {
  data?: Table & {
    items?: ({
      name?: string
    } & MainSettingsForm)[]
  }
}
export type GetProjectMainSettingsApiArg = {
  /** Project ID */
  id: number
}
export type PostProjectUpdateMainSettingsApiResponse =
  /** status 200 Successful response */ Success & {
    data?: Table & {
      items?: ({
        name?: string
      } & MainSettingsForm)[]
    }
  }
export type PostProjectUpdateMainSettingsApiArg = {
  body: {
    /** Scenario for the update */
    scenario?: 'update_brand' | 'update_devices'
    /** `In all scenarios`. ID of the project. */
    id?: number
    /** `Scenario = update_brand`. String brand name. */
    brand_name?: string
    /** `Scenario = update_brand`. Array of string brand variants. */
    brand_variants?: string[]
    /** `Scenario = update_brand`. Array of string domains. */
    domains?: string[]
    /** `Scenario = update_devices`. Array of device objects. */
    devices?: {
      id?: number
      name?: string
    }[]
  }
}
export type GetProjectLocationsApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: ProjectLocationRow[]
  }
}
export type GetProjectLocationsApiArg = {
  /** The ID of the project */
  projectId: number
  /** page number */
  page?: number
  /** rows per page */
  'per-page'?: number
  /** sort order, prefix (-) for reverse */
  sort?: string
}
export type PostProjectUpdateLocationsApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: ProjectLocationRow[]
  }
}
export type PostProjectUpdateLocationsApiArg = {
  body: {
    project_id?: number
    /** Array of location objects */
    data?: Location[]
  }
}
export type GetProjectAvailableCountriesApiResponse = /** status 200  */ Success & {
  data?: Table & {
    items?: AvailableCountryRow[]
  }
}
export type GetProjectAvailableCountriesApiArg = {
  /** ID of the project */
  projectId: number
}
export type GetProjectLocationsDefaultSettingsApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: ProjectLocationDefaultsRow[]
  }
}
export type GetProjectLocationsDefaultSettingsApiArg = {
  /** Array of country ids; comma separated, `country_ids[]=1&country_ids[]=2` is accepted too */
  countryIds: number[]
  /** page number */
  page?: number
  /** rows per page */
  'per-page'?: number
  /** sort order, prefix (-) for reverse */
  sort?: string
}
export type GetProjectTermsApiResponse = /** status 200  */ Success & {
  data?: Table & {
    items?: ProjectTermRow[]
  }
}
export type GetProjectTermsApiArg = {
  projectId?: number
}
export type PostProjectUpdateTermsApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: ProjectTermRow[]
  }
}
export type PostProjectUpdateTermsApiArg = {
  body: {
    project_id?: number
    /** Array of term settings objects */
    data?: TermSettings[]
  }
}
export type PostProjectSendWeeklyReportTelegramApiResponse =
  /** status 200 Weekly report sent successfully */ Success
export type PostProjectSendWeeklyReportTelegramApiArg = {
  projectId: number
}
export type PostProjectSendWeeklyReportEmailApiResponse =
  /** status 200 Weekly report sent successfully */ Success
export type PostProjectSendWeeklyReportEmailApiArg = {
  projectId: number
}
export type PostProjectSendAlertTelegramApiResponse =
  /** status 200 Alert about new publishers sent successfully */ Success & {
    data?: {
      send?: number
      errors?: number
    }
  }
export type PostProjectSendAlertTelegramApiArg = {
  projectId: number
}
export type PostProjectSendAlertEmailApiResponse =
  /** status 200 Alert about new publishers sent successfully */ Success & {
    data?: {
      send?: number
      errors?: number
    }
  }
export type PostProjectSendAlertEmailApiArg = {
  projectId: number
}
export type PostProjectSendTmAlertTelegramApiResponse =
  /** status 200 Alert about TM infringement sent successfully */ Success & {
    data?: NotificationSendStat
  }
export type PostProjectSendTmAlertTelegramApiArg = {
  projectId: number
}
export type PostProjectSendTmAlertEmailApiResponse =
  /** status 200 Alert about TM infringement sent successfully */ Success & {
    data?: NotificationSendStat
  }
export type PostProjectSendTmAlertEmailApiArg = {
  projectId: number
}
export type GetProjectDownloadReportApiResponse = unknown
export type GetProjectDownloadReportApiArg = {
  /** ID of the project */
  projectId: number
}
export type GetProjectBrandDomainsApiResponse = /** status 200  */ Success & {
  data?: string[]
}
export type GetProjectBrandDomainsApiArg = {
  /** ID of the project */
  projectId: number
  /** Example url to get domain from */
  url: string
}
export type PostProjectDeleteDemoProjectApiResponse = /** status 200 Ok */ Success
export type PostProjectDeleteDemoProjectApiArg = void
export type PostReferralCreateLinkApiResponse = /** status 200 Ok */ Success & {
  data?: ReferralLinkCreated
}
export type PostReferralCreateLinkApiArg = void
export type PostReferralDeleteLinkApiResponse = /** status 200 Ok */ Success & {
  data?: ReferralLinkStatus
}
export type PostReferralDeleteLinkApiArg = {
  id: number
}
export type PostReferralClickApiResponse = /** status 200 Ok */ Success & {
  data?: ReferralClickResult
}
export type PostReferralClickApiArg = {
  code: string
  refCookieId?: string
}
export type GetReferralLinkListApiResponse = /** status 200 Ok */ Success & {
  data?: ReferralLinkListItem[]
}
export type GetReferralLinkListApiArg = void
export type GetReferralUserListApiResponse = /** status 200 Ok */ Success & {
  data?: ReferralUserListItem[]
}
export type GetReferralUserListApiArg = void
export type GetReferralBalanceApiResponse = /** status 200 Ok */ Success & {
  data?: ReferralBalance
}
export type GetReferralBalanceApiArg = void
export type GetReferralConversionStatApiResponse = /** status 200 Ok */ Success & {
  data?: ReferralConversionStat
}
export type GetReferralConversionStatApiArg = {
  date?: string
}
export type GetReferralStatByMonthApiResponse = /** status 200 Ok */ Success & {
  data?: ReferralStatByMonthItem[]
}
export type GetReferralStatByMonthApiArg = {
  year: number
}
export type PostReferralPayoutRequestApiResponse = /** status 200 Ok */ Success
export type PostReferralPayoutRequestApiArg = void
export type GetReferralPayoutsListApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: ReferralPayoutItem[]
  }
}
export type GetReferralPayoutsListApiArg = void
export type GetReferralTermsApiResponse = /** status 200 Ok */ Success & {
  data?: ReferralTerms
}
export type GetReferralTermsApiArg = void
export type GetResearchKeywordsApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: ResearchKeywordsItem[]
  }
}
export type GetResearchKeywordsApiArg = {
  /** PHP array syntax: project_ids[]=1&project_ids[]=2; a single plain project_ids=1 works too */
  projectIds: number[]
  /** PHP array syntax: country_ids[]=1&country_ids[]=2 */
  countryIds?: number[]
  keyword?: string
  /** Comma-separated list of domains */
  domain?: string[]
  adsCount?: string
  /** page number */
  page?: number
  /** rows per page */
  'per-page'?: number
  /** sort order, prefix (-) for reverse */
  sort?: string
  /** export as file */
  export?: 'csv' | 'xlsx' | 'fast_xlsx'
  /** comma separated list; `exportColumns[]=a&exportColumns[]=b` is accepted too */
  exportColumns?: string[]
  date?: string
}
export type GetResearchKeywordsDateRangeApiResponse = /** status 200 Ok */ Success & {
  /** date => ads count; UInt64 from ClickHouse, comes as string */
  data?: {
    [key: string]: string
  }
}
export type GetResearchKeywordsDateRangeApiArg = {
  /** PHP array syntax: project_ids[]=1&project_ids[]=2; a single plain project_ids=1 works too */
  projectIds: number[]
  /** PHP array syntax: country_ids[]=1&country_ids[]=2 */
  countryIds?: number[]
  keyword?: string
  /** Comma-separated list of domains */
  domain?: string[]
  adsCount?: string
  date?: string
}
export type PostResearchKeywordsChartApiResponse = /** status 200 Ok */ Success & {
  data?: ResearchChartSeries[]
}
export type PostResearchKeywordsChartApiArg = {
  body: {
    date_group?: 'hour' | 'day' | 'week' | 'month'
    date?: string
    chart_keywords?: string[]
    project_ids?: number[]
    country_ids?: number[]
  }
}
export type GetResearchCompetitorsApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: ResearchCompetitorsItem[]
  }
}
export type GetResearchCompetitorsApiArg = {
  /** comma separated */
  projectIds: number[]
  /** PHP array syntax: country_ids[]=1&country_ids[]=2 */
  countryIds?: number[]
  /** Comma-separated list of domains */
  domain?: string[]
  /** PHP array syntax: kinds[]=a&kinds[]=b */
  kinds?: string[]
  /** PHP array syntax: sub_kinds[]=a&sub_kinds[]=b */
  subKinds?: string[]
  kind?: string
  subKind?: string
  adsCount?: string
  swVisits?: string
  visibility?: string
  isIgnored?: boolean
  isPpc?: boolean
  id?: number
  priorityVendorId?: number
  createdAt?: string
  notice?: string
  /** page number */
  page?: number
  /** rows per page */
  'per-page'?: number
  /** sort order, prefix (-) for reverse */
  sort?: string
  /** export as file */
  export?: 'csv' | 'xlsx' | 'fast_xlsx'
  /** comma separated list; `exportColumns[]=a&exportColumns[]=b` is accepted too */
  exportColumns?: string[]
  date?: string
}
export type GetResearchCompetitorsDateRangeApiResponse = /** status 200 Ok */ Success & {
  /** date => ads count; UInt64 from ClickHouse, comes as string */
  data?: {
    [key: string]: string
  }
}
export type GetResearchCompetitorsDateRangeApiArg = {
  /** comma separated */
  projectIds?: number[]
  /** PHP array syntax: country_ids[]=1&country_ids[]=2 */
  countryIds?: number[]
  /** Comma-separated list of domains */
  domain?: string[]
  /** PHP array syntax: kinds[]=a&kinds[]=b */
  kinds?: string[]
  /** PHP array syntax: sub_kinds[]=a&sub_kinds[]=b */
  subKinds?: string[]
  kind?: string
  subKind?: string
  adsCount?: string
  swVisits?: string
  visibility?: string
  isIgnored?: boolean
  isPpc?: boolean
  id?: number
  priorityVendorId?: number
  date?: string
}
export type PostResearchCompetitorsChartApiResponse = /** status 200 Ok */ Success & {
  data?: ResearchChartSeries[]
}
export type PostResearchCompetitorsChartApiArg = {
  body: {
    date_group?: 'hour' | 'day' | 'week' | 'month'
    date?: string
    chart_site_ids?: number[]
    project_ids?: number[]
    country_ids?: number[]
  }
}
export type GetResearchCompetitorsColumnApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: ResearchCompetitorsColumnItem[]
  }
}
export type GetResearchCompetitorsColumnApiArg = {
  /** page number */
  page?: number
  /** rows per page */
  'per-page'?: number
  /** sort order, prefix (-) for reverse */
  sort?: string
  projectId: number
  countryId?: number
  /** domain */
  domain: string
  /** keyword */
  keyword?: string
  date?: string
  /** export as file */
  export?: 'csv' | 'xlsx' | 'fast_xlsx'
}
export type GetResearchKeywordsColumnAdvertisersApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: ResearchKeywordsColumnAdvertisersItem[]
  }
}
export type GetResearchKeywordsColumnAdvertisersApiArg = {
  /** page number */
  page?: number
  /** rows per page */
  'per-page'?: number
  /** sort order, prefix (-) for reverse */
  sort?: string
  projectId: number
  countryId?: number
  /** keyword */
  keyword?: string
  date?: string
  /** export as file */
  export?: 'csv' | 'xlsx' | 'fast_xlsx'
}
export type GetResearchAdvertisingApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: AdvertisingResearchItems[]
  }
}
export type GetResearchAdvertisingApiArg = {
  /** page number */
  page?: number
  /** rows per page */
  'per-page'?: number
  /** sort order, prefix (-) for reverse */
  sort?: string
  /** export as file */
  export?: 'csv' | 'xlsx' | 'fast_xlsx'
  /** comma separated list; `exportColumns[]=a&exportColumns[]=b` is accepted too */
  exportColumns?: string[]
  date?: string
  projectId: number
  /** Comma-separated list of domains */
  site?: string[]
  countryId?: number
  engineId?: number
  /** Comma-separated list of keywords */
  keyword?: string[]
  /** Comma-separated list of keyword IDs from /filter/keywords */
  keywordId?: number[]
  /** Comma-separated list of landing URLs */
  landing?: string[]
  /** Comma-separated list of landing IDs from /filter/advertiser-landing */
  landingId?: string[]
  hasBrand?: boolean
  /** Include links of hidden affiliates */
  showHidden?: boolean
  /** Filter names applied as exclusion (NOT) instead of inclusion. Supported: landing, landing_id, keyword, keyword_id */
  reversedFilters?: string[]
}
export type GetResearchAdvertisingKeywordApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: AdvertisingResearchKeywordItems[]
  }
}
export type GetResearchAdvertisingKeywordApiArg = {
  /** page number */
  page?: number
  /** rows per page */
  'per-page'?: number
  /** sort order, prefix (-) for reverse */
  sort?: string
  /** export as file */
  export?: 'csv' | 'xlsx' | 'fast_xlsx'
  /** comma separated list; `exportColumns[]=a&exportColumns[]=b` is accepted too */
  exportColumns?: string[]
  date?: string
  title?: string
  url?: string
  projectId: number
  /** Comma-separated list of domains */
  site?: string[]
  countryId?: number
  engineId?: number
  /** Comma-separated list of keywords */
  keyword?: string[]
  /** Comma-separated list of keyword IDs from /filter/keywords */
  keywordId?: number[]
  /** Comma-separated list of landing URLs */
  landing?: string[]
  /** Comma-separated list of landing IDs from /filter/advertiser-landing */
  landingId?: string[]
  hasBrand?: boolean
  /** Include links of hidden affiliates */
  showHidden?: boolean
  /** Filter names applied as exclusion (NOT) instead of inclusion. Supported: landing, landing_id, keyword, keyword_id */
  reversedFilters?: string[]
}
export type GetResearchAdvertisingAffiliatesApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: AdvertisingAffiliatesItems[]
  }
}
export type GetResearchAdvertisingAffiliatesApiArg = {
  /** page number */
  page?: number
  /** rows per page */
  'per-page'?: number
  /** sort order, prefix (-) for reverse */
  sort?: string
  /** export as file */
  export?: 'csv' | 'xlsx' | 'fast_xlsx'
  /** comma separated list; `exportColumns[]=a&exportColumns[]=b` is accepted too */
  exportColumns?: string[]
  date?: string
  projectId: number
  /** Comma-separated list of domains */
  site?: string[]
  countryId?: number
  engineId?: number
  /** Comma-separated list of keywords */
  keyword?: string[]
  /** Comma-separated list of keyword IDs from /filter/keywords */
  keywordId?: number[]
  /** Comma-separated list of landing URLs */
  landing?: string[]
  /** Comma-separated list of landing IDs from /filter/advertiser-landing */
  landingId?: string[]
  hasBrand?: boolean
  showHidden?: boolean
  /** Filter names applied as exclusion (NOT) instead of inclusion. Supported: country_id, engine_id, site, landing, landing_id, keyword, keyword_id */
  reversedFilters?: string[]
}
export type GetResearchSeoPositionApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: SeoPositionItems[]
  }
}
export type GetResearchSeoPositionApiArg = {
  /** page number */
  page?: number
  /** rows per page */
  'per-page'?: number
  /** sort order, prefix (-) for reverse */
  sort?: string
  /** export as file */
  export?: 'csv' | 'xlsx' | 'fast_xlsx'
  /** comma separated list; `exportColumns[]=a&exportColumns[]=b` is accepted too */
  exportColumns?: string[]
  date?: string
  projectId: number
  ownDomain?: string
  countryId?: number
  engineId?: number
  /** Comma-separated list of keywords */
  keyword?: string[]
  /** Comma-separated list of keyword IDs from /filter/keywords */
  keywordId?: number[]
  noSerpPresence?: boolean
  /** Comma-separated list of landing URLs */
  landing?: string[]
  /** Comma-separated list of landing IDs from /filter/advertiser-landing */
  landingId?: string[]
}
export type PostResearchSeoPositionChartApiResponse = /** status 200 Ok */ Success & {
  data?: SeoPositionChartItems[]
}
export type PostResearchSeoPositionChartApiArg = {
  body: {
    date?: string
    project_id: number
    country_id?: number
    engine_id?: number
    site?: string
    keyword_ids: number[]
  }
}
export type GetResearchBrandPresenceApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: BrandPresenceItems[]
  }
}
export type GetResearchBrandPresenceApiArg = {
  /** page number */
  page?: number
  /** rows per page */
  'per-page'?: number
  /** sort order, prefix (-) for reverse */
  sort?: string
  /** export as file */
  export?: 'csv' | 'xlsx' | 'fast_xlsx'
  /** comma separated list; `exportColumns[]=a&exportColumns[]=b` is accepted too */
  exportColumns?: string[]
  date?: string
  projectId: number
  countryId?: number
  engineId?: number
  noSerpPresence?: boolean
  /** Comma-separated list of domains */
  site?: string[]
  /** Comma-separated list of keywords */
  keyword?: string[]
  /** Comma-separated list of keyword IDs from /filter/keywords */
  keywordId?: number[]
  /** Comma-separated list of landing URLs */
  landing?: string[]
  /** Comma-separated list of landing IDs from /filter/advertiser-landing */
  landingId?: string[]
}
export type GetResearchBrandPresencePagesApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: BrandPresencePagesItems[]
  }
}
export type GetResearchBrandPresencePagesApiArg = {
  /** page number */
  page?: number
  /** rows per page */
  'per-page'?: number
  /** sort order, prefix (-) for reverse */
  sort?: string
  /** export as file */
  export?: 'csv' | 'xlsx' | 'fast_xlsx'
  /** comma separated list; `exportColumns[]=a&exportColumns[]=b` is accepted too */
  exportColumns?: string[]
  date?: string
  projectId: number
  keywordId: number
  countryId?: number
  engineId?: number
  /** Comma-separated list of domains */
  site?: string[]
  /** Comma-separated list of landing URLs */
  landing?: string[]
  /** Comma-separated list of landing IDs from /filter/advertiser-landing */
  landingId?: string[]
  isSeo?: boolean
}
export type GetResearchLiveApiResponse = /** status 200 Ok */ Success & {
  data?: {
    items?: ResearchLiveItem[]
  } & {
    stat?: {
      execTime?: number
      successCount?: number
      requestsCount?: number
      proxyVendors?: {
        pid?: number
        vendor?: number
        success?: boolean
        linksCount?: number
      }[]
    }
  }
} & {
  allow_decloak?: boolean
}
export type GetResearchLiveApiArg = {
  deviceTypeId: number
  countryId: number
  engineId: number
  keyword: string
  excludeIds?: string
}
export type GetResearchLiveRedirectsApiResponse =
  | /** status 200 Ok */ Wait
  | (Success & {
      data?: {
        redirects?: string[]
      }
    })
export type GetResearchLiveRedirectsApiArg = {
  deviceTypeId: number
  countryId: number
  engineId: number
  linkUrl: string
  linkTitle: string
  linkText: string
  linkDomain: string
  keyword?: string
  isSeoLink: boolean
  excludeIds?: string
  hash?: string
  /** `wait` polls the job started by the first call */
  requestType?: 'wait'
  /** attempts left, taken from the previous wait response */
  leftAttempts?: number
}
export type GetResearchLiveDecloakAutoApiResponse = /** status 200 Ok */ Success
export type GetResearchLiveDecloakAutoApiArg = {
  deviceTypeId: number
  countryId: number
  engineId: number
  linkUrl: string
  linkTitle: string
  linkText: string
  linkDomain: string
  keyword?: string
  isSeoLink?: boolean
}
export type PostSiteLoginApiResponse = /** status 200 Ok */ Success & {
  data?: LoginUser
}
export type PostSiteLoginApiArg = {
  body: {
    /** E-Mail */
    email?: string
    /** Пароль */
    password?: string
    rememberMe?: boolean
  }
}
export type PostSiteSignupApiResponse = /** status 200 Ok */ Success & {
  data?: LoginUser
}
export type PostSiteSignupApiArg = {
  body: {
    scenario?: 'first' | 'first_oauth' | 'second'
    /** User full name */
    fullName?: string
    /** E-Mail */
    email?: string
    /** utm метки, JSON-строка с ключами term, medium, source, content, campaign */
    utm?: string
    /** Subscribe to news */
    notifyNews?: boolean
    /** Password */
    password?: string
    /** Company name */
    companyName?: string
    /** Company website url */
    companyWebsite?: string
    /** Please tell us about your interest */
    other?: string
    /** Referrer Cookie id */
    ref_cookie_id?: string
    /** Company role */
    companyRole?:
      | 'affiliate_manager'
      | 'marketing_manager'
      | 'paid_search_manager'
      | 'media_buyer'
      | 'product_manager'
      | 'other'
    /** Preferred contact method */
    contactMethod?: 'telegram' | 'whatsapp' | 'linkedin' | 'email' | 'skype'
    /** Contact details */
    contactDetails?: string
    /** Pass as array of strings, possible values:`{brand_bidding,trademark_abuse,coupon_code_compliance,language_compliance,competitor_analysis,uncloaking,other}` */
    assistanceRequest?: string[]
  }
}
export type GetSiteCurrentuserApiResponse = /** status 200 Ok */ Success & {
  data?: LoginUser
}
export type GetSiteCurrentuserApiArg = void
export type PostSiteContactApiResponse = /** status 200 Ok */ Success
export type PostSiteContactApiArg = {
  body: {
    /** имя пользователя */
    name: string
    /** E-Mail */
    email: string
    /** название компании */
    company: string
    /** сайт бренда */
    brand_website: string
    /** промокод */
    promocode: string
    /** сообщение от пользователя */
    message?: string
    /** мессенджер */
    messenger?: string
    /** комментарий */
    comment?: string
    /** источник регистрации */
    source?: 'bluepear' | 'robuscan'
    /** utm метки, JSON-строка с ключами term, medium, source, content, campaign */
    utm?: string
    /** токен рекапчи */
    reCaptcha?: string
  }
}
export type PostSiteRequestDemoApiResponse = /** status 200 Ok */ Success & {
  data?: {
    /** saved application */
    app_form?: object
    message?: string
  }
}
export type PostSiteRequestDemoApiArg = {
  body: {
    name: string
    email: string
    company: string
    brand_website: string
    /** сообщение от пользователя */
    message?: string
    messenger?: string
    /** источник регистрации */
    source?: 'bluepear' | 'robuscan'
    /** utm метки, JSON-строка с ключами term, medium, source, content, campaign */
    utm?: string
    /** токен рекапчи */
    reCaptcha?: string
  }
}
export type PostSiteLogoutApiResponse = /** status 200 Ok */ Success
export type PostSiteLogoutApiArg = void
export type PostSiteRequestPasswordResetApiResponse = /** status 200 Ok */ Success
export type PostSiteRequestPasswordResetApiArg = {
  body: {
    /** E-Mail */
    email?: string
  }
}
export type PostSiteResetPasswordApiResponse = /** status 200 Ok */ Success
export type PostSiteResetPasswordApiArg = {
  /** токен вшитый в ссылку из письма */
  token?: string
  /** если инвайт, то = true */
  invite?: boolean
  body: {
    /** new password */
    password?: string
    /** repeat new password */
    password_repeat?: string
  }
}
export type PostSiteVerifyEmailApiResponse = /** status 200 Ok */ Success
export type PostSiteVerifyEmailApiArg = {
  /** токен вшитый в ссылку из письма */
  token?: string
}
export type PostSiteGoogleOauthApiResponse = /** status 200 Ok */ Success
export type PostSiteGoogleOauthApiArg = {
  credential?: string
  code?: string
  state?: string
}
export type GetSiteGoogleReportOauthUrlApiResponse = /** status 200 Ok */ Success & {
  data?: {
    auth_url?: string
  }
}
export type GetSiteGoogleReportOauthUrlApiArg = void
export type PostSiteGoogleReportOauthSaveApiResponse = /** status 200 Ok */ Success & {
  data?: {
    email?: string
  }
}
export type PostSiteGoogleReportOauthSaveApiArg = {
  code?: string
}
export type PostSiteGoogleReportOauthDeleteTokenApiResponse = /** status 200 Ok */ Success
export type PostSiteGoogleReportOauthDeleteTokenApiArg = {
  body: {
    email?: string
  }
}
export type PostSiteSendVerificationEmailApiResponse = /** status 200 Ok */ Success
export type PostSiteSendVerificationEmailApiArg = void
export type PostSiteHideNotificationApiResponse = /** status 200 Ok */ Success
export type PostSiteHideNotificationApiArg = {
  id?: number
}
export type GetSiteArticleSettingsApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: {
      articles?: ArticleSettingsFilter[]
      buttons?: ArticleSettingsFilter[]
      contacts?: ArticleSettingsFilter[]
      feedback?: boolean
    }
  }
}
export type GetSiteArticleSettingsApiArg = void
export type GetSiteFaqApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: FaqFilter[]
  }
}
export type GetSiteFaqApiArg = void
export type GetSiteCustomerReviewsApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: CustomerReviewFilter[]
  }
}
export type GetSiteCustomerReviewsApiArg = void
export type GetTariffListApiResponse = /** status 200 Ok */ Success & {
  data?: Tariff[]
}
export type GetTariffListApiArg = void
export type GetTeamManagementListApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: TeamListFilter[]
  }
}
export type GetTeamManagementListApiArg = {
  /** page number */
  page?: number
  /** rows per page */
  'per-page'?: number
  /** sort order, prefix (-) for reverse */
  sort?: string
}
export type PostTeamManagementAddUserApiResponse = /** status 200 Ok */ Success
export type PostTeamManagementAddUserApiArg = {
  teamAddUserForm: TeamAddUserForm
}
export type GetTeamManagementEditUserApiResponse = /** status 200 Ok */ Success & {
  data?: TeamEditUserInfo
}
export type GetTeamManagementEditUserApiArg = {
  id?: number
}
export type PostTeamManagementEditUserApiResponse = /** status 200 Ok */ Success
export type PostTeamManagementEditUserApiArg = {
  teamEditUserForm: TeamEditUserForm
}
export type PostTeamManagementUserChangeStatusApiResponse = /** status 200 Ok */ Success
export type PostTeamManagementUserChangeStatusApiArg = {
  teamUserChangeStatusForm: TeamUserChangeStatusForm
}
export type PostTeamManagementSendInviteApiResponse = /** status 200 Ok */ Success
export type PostTeamManagementSendInviteApiArg = {
  teamSendInviteForm: TeamSendInviteForm
}
export type GetTmInfringementsListApiResponse = /** status 200 Ok */ Success & {
  data?: Table & {
    items?: TmInfringementRowDomainGeo[]
    tab_count?: TmInfringementsTabCounters
  }
}
export type GetTmInfringementsListApiArg = {
  projectId: number
  /** defaults to the active trademark */
  trademarkId?: number
  tab?: 'to_submit' | 'in_progress' | 'removed'
  /** in_progress tab only */
  status?: 'submitted' | 'accepted' | 'rejected'
  /** Comma-separated list of country IDs */
  countryId?: number[]
  /** domain substring filter */
  site?: string
  /** Google case id */
  caseId?: string
  engineId?: number
  /** to_submit tab only */
  onlyRegistered?: boolean
  showWhitelisted?: boolean
  /** comma-separated infringement ids (bulk export) */
  ids?: number[]
  /** page number */
  page?: number
  /** rows per page */
  'per-page'?: number
  /** sort order, prefix (-) for reverse */
  sort?: string
  /** export as file */
  export?: 'csv' | 'xlsx' | 'fast_xlsx'
  /** comma separated list; `exportColumns[]=a&exportColumns[]=b` is accepted too */
  exportColumns?: string[]
  date?: string
}
export type GetTmInfringementsCounterApiResponse = /** status 200 Ok */ Success & {
  data?: TmInfringementsTabCounters
}
export type GetTmInfringementsCounterApiArg = {
  projectId: number
  /** defaults to the active trademark */
  trademarkId?: number
  /** Comma-separated list of country IDs */
  countryId?: number[]
  /** domain substring filter */
  site?: string
  /** Google case id */
  caseId?: string
  engineId?: number
  /** affects to_submit only */
  onlyRegistered?: boolean
  showWhitelisted?: boolean
  date?: string
}
export type GetTmInfringementsDomainSummaryApiResponse = /** status 200 Ok */ Success & {
  data?: DomainGeoStatus[]
}
export type GetTmInfringementsDomainSummaryApiArg = {
  projectId: number
  domain: string
  /** Comma-separated list of country IDs */
  countryId?: number[]
}
export type GetTmInfringementsSuccessReportApiResponse = /** status 200 Ok */ Success & {
  data?: SuccessReportTrend
}
export type GetTmInfringementsSuccessReportApiArg = {
  projectId: number
  infringementId: number
}
export type GetTmInfringementsHistoryApiResponse = /** status 200 Ok */ Success & {
  data?: SubmissionHistoryRecordOnePerCase[]
}
export type GetTmInfringementsHistoryApiArg = {
  projectId: number
  infringementId: number
}
export type GetTmInfringementsViewReplyApiResponse = /** status 200 Ok */ Success & {
  data?: GoogleRepliesForACase
}
export type GetTmInfringementsViewReplyApiArg = {
  projectId: number
  /** internal case id from /history */
  caseId: number
}
export type PostTmInfringementsWhitelistApiResponse = /** status 200 Ok */ Success
export type PostTmInfringementsWhitelistApiArg = {
  body: {
    project_id: number
    /** one or many domains; a comma-separated string is also accepted */
    domain: string[]
    is_whitelisted: boolean
  }
}
export type PostTmInfringementsSubmitApiResponse = /** status 200 Ok */ Success & {
  data?: PerCountrySubmitResultKeyedByInfringementId
}
export type PostTmInfringementsSubmitApiArg = {
  body: {
    project_id: number
    /** comma-separated or array; one id per domain is enough — every registered country of each domain is submitted */
    infringement_ids: number[]
    /** the compliance service forwards Google's reply to the current user's email */
    forward_replies_to_my_email?: boolean
    filter_context?: string
  }
}
export type PostTmInfringementsResubmitApiResponse = /** status 200 Ok */ Success & {
  data?: PerCountrySubmitResultKeyedByInfringementId
}
export type PostTmInfringementsResubmitApiArg = {
  body: {
    project_id: number
    infringement_ids: number[]
    forward_replies_to_my_email?: boolean
  }
}
export type GetTrademarkListApiResponse = /** status 200 Ok */ Success & {
  data?: TrademarkListRow[]
}
export type GetTrademarkListApiArg = {
  projectId: number
}
export type GetTrademarkCardApiResponse = /** status 200 Ok */ Success & {
  data?: TrademarkCard
}
export type GetTrademarkCardApiArg = {
  projectId: number
  trademarkId?: number
}
export type PostTrademarkCreateApiResponse = /** status 200 Ok */ Success & {
  data?: Trademark
}
export type PostTrademarkCreateApiArg = {
  body: {
    project_id: number
    name: string
    owner?: string
    owner_website?: string
    registrations: {
      country_id?: number
      registration_number?: string
    }[]
    authorisation_letter: Blob
  }
}
export type PostTrademarkUpdateApiResponse = /** status 200 Ok */ Success & {
  data?: Trademark
}
export type PostTrademarkUpdateApiArg = {
  body: {
    project_id: number
    trademark_id: number
    fields_to_update: {
      name?: string
      owner?: string
      owner_website?: string
    }
  }
}
export type PostTrademarkUploadLetterApiResponse = /** status 200 Ok */ Success & {
  data?: {
    authorisation_letter_url?: string
    authorisation_letter_name?: string
    uploaded_at?: string
  }
}
export type PostTrademarkUploadLetterApiArg = {
  body: {
    project_id: number
    trademark_id: number
    authorisation_letter: Blob
  }
}
export type PostTrademarkRegistrationAddApiResponse = /** status 200 Ok */ Success & {
  data?: {
    registration_id?: number
  }
}
export type PostTrademarkRegistrationAddApiArg = {
  body: {
    project_id: number
    trademark_id: number
    country_id: number
    registration_number: string
  }
}
export type PostTrademarkRegistrationUpdateApiResponse = /** status 200 Ok */ Success
export type PostTrademarkRegistrationUpdateApiArg = {
  body: {
    project_id: number
    trademark_id: number
    registration_id: number
    country_id?: number
    registration_number?: string
  }
}
export type PostTrademarkRegistrationDeleteApiResponse = /** status 200 Ok */ Success
export type PostTrademarkRegistrationDeleteApiArg = {
  body: {
    project_id: number
    trademark_id: number
    registration_id: number
  }
}
export type PostTrademarkArchiveApiResponse = /** status 200 Ok */ Success & {
  data?: Trademark
}
export type PostTrademarkArchiveApiArg = {
  body: {
    project_id: number
    trademark_id: number
  }
}
export type PostTrademarkActivateApiResponse = /** status 200 Ok */ Success & {
  data?: Trademark
}
export type PostTrademarkActivateApiArg = {
  body: {
    project_id: number
    trademark_id: number
  }
}
export type PostUserRequestChangeTariffApiResponse = /** status 200 Ok */ Success
export type PostUserRequestChangeTariffApiArg = {
  requestChangeTariffForm: RequestChangeTariffForm
}
export type GetUserCurrentTariffDetailsApiResponse = /** status 200 Ok */ Success & {
  data?: CurrentTariffDetails
}
export type GetUserCurrentTariffDetailsApiArg = void
export type PostUserSendFeedbackApiResponse = /** status 200 Ok */ Success
export type PostUserSendFeedbackApiArg = {
  sendFeedbackForm: SendFeedbackForm
}
export type PostUserGetStripePortalLinkApiResponse = /** status 200 Ok */ Success & {
  data?: {
    url?: string
  }
}
export type PostUserGetStripePortalLinkApiArg = void
export type PostUserRequestChangeReferralTermsApiResponse = /** status 200 Ok */ Success
export type PostUserRequestChangeReferralTermsApiArg = void
export type PostUserConfirmContactApiResponse = /** status 200 Ok */ Success
export type PostUserConfirmContactApiArg = {
  confirmContactForm: ConfirmContactForm
}
export type Success = {
  /** status of request */
  success?: boolean
  /** datetime of requests */
  dt?: string
  /** is user authenticated */
  is_auth?: boolean
  /** present when success=false; attribute name => list of messages */
  errors?: {
    [key: string]: string[]
  }
  /** virtual user has been switched, frontend must reload */
  need_reload_page?: boolean
}
export type Table = {
  /** current page number */
  page: number
  /** total pages */
  pageCount: number
  /** total rows */
  total: number
  /** rows per page */
  pageSize: number
  sort: {
    attributes: string[]
    current: {
      [key: string]: number
    }
    default: {
      [key: string]: number
    }
  }
}
export type AdvertiserCard = {
  advertiser_id?: string
  name?: string
  location?: string
  verified?: boolean
  verified_by?: string
  transparency_url?: string
}
export type AdOverviewAd = {
  id: string
  finish_domain: string
  title: string
  text: string
  position_global: number
  is_top: boolean
  /** comma separated */
  keywords: string
  redirects: string[]
  additionalRedirects: string[][]
  /** plain text of a collapsed list: names newline separated, empty lines must be skipped; with more than 3 names the last line is a 'More: N' label, not a name; empty string when none */
  engines: string
  search_screen_url: string | null
  link_screen_url: string | null
  shopping_ad_preview_url: string | null
  /** plain text of a collapsed list: names newline separated, empty lines must be skipped; with more than 3 names the last line is a 'More: N' label, not a name; empty string when none */
  cities: string
  /** plain text of a collapsed list: names newline separated, empty lines must be skipped; with more than 3 names the last line is a 'More: N' label, not a name; empty string when none */
  countries: string
  devices: string
  last_found: string
  is_decloak: boolean
  black_hat_domain: string | null
  affiliate_id: string | null
  advertiser: AdvertiserCard | null
}
export type AdOverviewAffiliate = {
  affiliate_id: string
  count: number
  publisher_id: number
  last_updated: string
  first_updated: string
  comment: string
  /** boolean formatted by the grid: 1 = hidden, empty string = visible */
  is_hidden: '1' | ''
  domain: string
}
export type AdOverviewAffiliateAd = {
  affiliate_id: string
  id: string
  text: string
  title: string
  finish_domain: string
  found: string
  keyword: string
  country: string
  city: string
  engine: string
  device: string
  position_global: number
  is_top: boolean
  redirects: string[]
  additionalRedirects: string[][]
  search_screen_url: string
  link_screen_url: string
}
export type Publisher = {
  id?: number
  created_at?: string
  updated_at?: string
  project?: string
  site?: string
  name?: string
  comment?: string
  is_hidden?: boolean
  email?: string
}
export type VirtualUser = {
  user_id?: number
  company_name?: string
}
export type AdvertiserReportsAllAdvertisersItems = {
  ads: {
    title?: string
    text?: string
    url?: string
    link_screen_url?: string | null
    search_screen_url?: string | null
    advertiser?: AdvertiserCard | null
    keyword?: string | null
    search_engine?: string
    ad_position?: number
    last_found?: string | null
    country?: string
    affiliate_id?: string | null
  }[]
  shopping_ads: {
    title?: string
    text?: string
    url?: string
    link_screen_url?: string | null
    search_screen_url?: string | null
    shopping_ad_preview_url?: string | null
    advertiser?: AdvertiserCard | null
    keyword?: string | null
    search_engine?: string
    ad_position?: number
    last_found?: string | null
    country?: string
    affiliate_id?: string | null
  }[]
  advertiser: string
  advertisers: {
    advertiser_id?: string
    name?: string
    location?: string
    verified?: boolean
    verified_by?: string
    transparency_url?: string
    search_engine?: string
    ads_count?: number
    last_found?: string
    countries?: {
      id?: number
      code?: string
      name?: string
    }[]
    affiliates?: {
      affiliate_id?: string
      publisher?: string
    }[]
  }[]
  keywords_count: number
  count: number
  count_total: number
  site_id: number | null
  /** empty string when the site has no settings yet */
  progress_status: 'unprocessed' | 'in_process' | 'completed' | ''
  is_hide: boolean
  is_decloak: boolean
  is_top: boolean
  visibility: number
  keywords: string[]
  affiliates: string[]
  /** UInt64 from ClickHouse, comes as string */
  affiliates_count: string
  last_found: string
  tags: string[]
  countries: {
    id?: number
    code?: string
    name?: string
  }[]
  last_url: string
}
export type AllAdvertisersTabCounters = {
  trademark_abuse?: string
  non_compliant_affiliates?: string
  coupon_sites?: string
  trademark_abuse_url?: string
}
export type AdvertiserReportsOrganicItems = {
  domain: string
  has_brand: boolean
  pages_count: number
  keywords_count: number
  affiliates_count: number
  position: number
  previous_position: number | null
  last_found: string
  is_hide: boolean
  tags: {
    id?: number
    name?: string
    color?: string
    type?: string
  }[]
  pages: {
    title?: string
    url?: string
  }[]
  keywords: string[]
  affiliates: string[]
}
export type SiteSettings = {
  project_id?: string
  domain?: string
  is_hide?: '0' | '1'
  is_affiliate?: '0' | '1'
  name?: string
  comment?: string
  status?: 'unprocessed' | 'in_process' | 'completed'
}
export type DecloakSettings = {
  project_id?: number
  country_id?: number
  domain?: string
  interval?: number | null
  last_try?: string | null
}
export type AffiliateListItem = {
  id: number
  publisher: string
  name: string | null
  pub_value: string
  email: string
  comment: string
  project_id: number
  project_name: string
  domains: string[]
  advertisers: string[]
  created_at: string
  updated_at: string
}
export type AffiliateLastAd = {
  id: number
  title: string
  text: string
  finish_domain: string
  found: string
  engine: string
  keyword: string
  country: string
  search_screen_url: string | null
  link_screen_url: string | null
  is_shopping_ad: boolean
  is_top: boolean
  shopping_ad_preview_url: string | null
  device: string
  affiliate: string
  advertiser: AdvertiserCard | null
  redirects: string[]
  additionalRedirects: string[][]
}
export type Affiliate = {
  id?: number
  publisher?: string
  name?: string | null
  pub_value?: string | null
  network_value?: string | null
  project_id?: number
  affiliate_network_id?: number
  type_id?: number
  status_id?: number
  is_hidden?: boolean
  is_hidden_by_user?: boolean
  is_hidden_by_system?: boolean
  is_repeat?: boolean
  email?: string | null
  comment?: string | null
  first_link_at?: string
  last_link_at?: string
  created_at?: string
  updated_at?: string
  resolved_at?: string | null
  link_type?: string[]
  created_by?: number
  updated_by?: number
  v?: number
}
export type TrackingParamConfig = {
  /** GET-ключ (стандартный режим) либо значение сегмента пути (path-based режим). */
  value?: string
  type?: 'affiliate' | 'network' | 'other'
  ignored_values?: string[]
  allowed_values?: string[]
}
export type AffiliateRuleFilter = {
  /** Affiliate Rule ID. */
  id: number
  /** Domain. */
  domain: string
  domain_zones: string[]
  aff_count_30d: number
  params: TrackingParamConfig[]
  params_string: string
  main_domain_zone: string
  url: string
  created_at: string
  enabled: boolean
  is_syncing: boolean
  /** Path-based режим: id передаются в сегментах пути URL, а не в GET-параметрах. */
  is_path_based: boolean
  /** Inline-превью path-based паттерна (роли по позициям сегментов). null для стандартных правил. */
  params_preview: string | null
}
export type AffiliateRuleForm = {
  /** `scenario = update_zones | update_status | update_params` . Affiliate Rule ID. */
  id?: number
  /** `scenario = create` . Project ID for Affiliate Rule. */
  project_id?: number
  /** `scenario = first_step` . Example URL for Affiliate Rule. */
  url?: string
  /** `scenario = update_status` . Status for Affiliate Rule. */
  enabled?: boolean
  /** `scenario = third_step | update_zones`. Array of domain zones. */
  domain_zones?: string[]
  /** `scenario = second_step | update_params`. Array of tracking params objects. */
  params?: TrackingParamConfig[]
  /** `scenario = first_step | second_step | third_step | create`. Path-based режим: значения берутся из сегментов пути URL (разделители `/ # & = ?`), а не из GET-параметров. По умолчанию false. На редактировании берётся из сохранённого правила. */
  is_path_based?: boolean
}
export type AffiliateRuleStatus = {
  publisher: string
  status: string
  status_id: number
}
export type NonCompliantAffiliatesTabCounters = {
  [key: string]: string
}
export type AdvertiserCardWithAggregates = AdvertiserCard & {
  search_engine?: string
  ads_count?: number
  countries?: {
    id?: number
    code?: string
    name?: string
  }[]
  last_found?: string
}
export type NonCompliantAffiliate = {
  id: number
  affiliate: string
  affiliate_name: string | null
  advertisers: AdvertiserCardWithAggregates[]
  ads_count: number
  network_name: string | null
  status_id: number
  project_id: number
  network_id: number
  affiliate_rule_id: number | null
  is_hidden: boolean
  has_shopping_ads: boolean
  is_only_shopping_ads: boolean
  pub_value: string
  network_value: string | null
  first_found: string
  last_found: string
  tags: string[]
  countries: {
    id?: number
    code?: string
    name?: string
  }[]
}
export type FilterData = {
  /** Date range (e.g., '2024-06-05 - 2024-07-05') */
  date: string
  /** ID of the project */
  project_id: number
  /** ID of the affiliate */
  affiliate_id: number
  /** E.g. 'utm_source=leadgid&wmid=79146' */
  affiliate: string
  /** ID of the network */
  network_id?: number
  /** ID of the country */
  country_id?: number
  /** Advertiser (site domain) */
  site?: string
  /** ID of the browser */
  browser_id?: number
  /** ID of the search engine */
  engine_id?: number
  /** ID of the city */
  city_id?: number
  /** Advertiser IDs from /filter/advertiser-names; a comma-separated string is accepted too */
  advertiser_id?: string[]
  /** Filter names applied as exclusion (NOT) instead of inclusion in the Full ads report, as in /ad-overview/ads */
  reversed_filters?: string[]
  /** Is hijack */
  is_hijack?: boolean
}
export type LastSendEmail = {
  subject: string | null
  body: string | null
  carbonCopy: string[]
  send_to: string[]
}
export type DecloakTimeFilter = {
  domains?: string[]
  countries?: number[]
  dates?: string[]
  times?: {
    id?: string
    time?: string
  }[]
}
export type DecloakCompareScreenshots = {
  decloak_screen_url?: string
  public_screen_url?: string
}
export type DecloakCompareHtml = {
  decloak_html_url?: string
  public_html_url?: string
}
export type DecloakCompareLinks = {
  decloak_links?: string[]
  decloak_additional_links?: string[]
  public_links?: string[]
  public_additional_links?: string[]
}
export type DecloakAd = {
  title?: string
  text?: string
  keyword?: string
  domain?: string
  created_at?: string
  engine?: string
  device?: string
  search_screen_url?: string
}
export type DecloakLive = {
  webScreen?: string
  webHtml?: string
  hash?: string
  ids?: string
  redirects?: string[]
  remain?: number
}
export type DomainTag = {
  id: string
  name: string
  color: string
  created_at: string
  updated_at: string
}
export type DomainTagByDomain = {
  id: string
  name: string
  color: string
}
export type DecloakResult = {
  webScreen?: string
  webHtml?: string
}
export type FilterProject = {
  id: number
  name: string
  is_demo: boolean
  has_paid_links: boolean
  has_seo_links: boolean
  has_shopping_ads: boolean
  /** false → Trademark Missing zero state */
  has_trademarks: boolean
  /** has_trademarks=true & false → No active trademarks zero state */
  has_active_trademarks: boolean
  /** has_active_trademarks=true & false → trademark is set up, but no infringements have been collected yet */
  has_tm_infringements: boolean
}
export type FilterCountry = {
  id: number
  code: string
  name: string
  /** present only when with_keywords_state=1 */
  keywords_state?: 'active' | 'deleted' | 'never'
}
export type AdvertiserDomains = {
  name: string
}
export type AdvertiserLandings = {
  landing_id: string
  name: string
}
export type IdName = {
  id: number
  name: string
}
export type FilterEngine = {
  name: string
  id: number
  allowed_country_ids: number[]
}
export type FilterAffiliate = {
  id?: number
  webmaster?: string
  name?: string
  comment?: string
}
export type NetworkFilter = {
  id: number
  name: string
  is_private: boolean
}
export type FilterBrowserLanguage = {
  /** Language code */
  id?: string
  /** Language name */
  name?: string
}
export type AdvertiserNamesFilter = {
  /** Саджест уникальных имён рекламодателей (advertiser) в рамках проекта.
    
    Имена берутся из advertiser_info через JOIN на link_advertiser, ограниченный
    линками проекта. Используется на страницах Paid Results / Ad Overview / PPC Compliance. */
  advertiser_id: string
  name: string
  engine_id: number
}
export type IanaTimeZoneWithTheCurrentUtcOffset = {
  id: string
  name: string
  /** UTC offset at the moment of the request, follows daylight saving time */
  offset: string
  /** default list; the rest are available via search */
  is_main: boolean
}
export type LanguageComplianceLastCheck = {
  url: string
  is_auto: boolean
  infringements_count: number
  hash: string
  affiliate: string
  last_check: string
  is_hidden: boolean
}
export type LanguageComplianceInProgress = {
  url: string
  affiliate: string
  check_count: number
  is_last_infringement: boolean
  last_check: string
  is_hidden: boolean
  state: string
  state_at: string
}
export type LanguageComplianceHistory = {
  url: string
  affiliate: string
  check_count: number
  is_last_infringement: boolean
  last_check: string
  is_hidden: boolean
  state: string
  state_at: string
}
export type LanguageComplianceHistoryDetail = {
  hash: string
  created_at: string
  infringements_count: number
  link_screen_url: string
}
export type LanguageComplianceReport = {
  created_at?: string
  url?: string
  link_screen_url?: string
  country?: string
  device?: string
  items?: string[]
}
export type LanguageComplianceProjectSuggest = {
  id?: number
  name?: string
}
export type LanguageComplianceCountrySuggest = {
  id?: number
  name?: string
}
export type LanguageCompliancePageSuggest = {
  /** fake */
  id?: string
  name?: string
}
export type LanguageComplianceAffiliateSuggest = {
  /** fake */
  id?: string
  name?: string
}
export type LanguageComplianceWordSuggest = {
  id?: number
  name?: string
}
export type LanguageComplianceUpdateState = {
  project_id: number
  /** Comma-separated list of country IDs */
  country_id: string
  urls: string[]
  state?: 'in_progress' | 'resolved'
  is_hidden?: 0 | 1
}
export type AlertTypeDeliverySettings = {
  enabled: boolean
  mode: 'instant' | 'scheduled'
  frequency: ('once_per_day' | 'multiple_per_day' | 'once_per_week' | 'multiple_per_week') | null
  timezone: string | null
  sends: {
    /** ISO weekday, weekly frequencies only */
    weekday?: number | null
    time: string
  }[]
}
export type ProjectNotificationRecipient = {
  channel: 'email' | 'tg'
  value: string
  /** Alert types for the recipient; every project recipient gets the weekly report */
  subscriptions: ('affiliates' | 'tm_infringements')[]
}
export type ProjectNotificationsCard = {
  types: {
    affiliates: AlertTypeDeliverySettings
    tm_infringements: AlertTypeDeliverySettings
  }
  weekly_report: boolean
  recipients: ProjectNotificationRecipient[]
}
export type AlertingScheduleOfOneAlertType = {
  type: 'affiliates' | 'tm_infringements'
  mode: 'instant' | 'scheduled'
  frequency: ('once_per_day' | 'multiple_per_day' | 'once_per_week' | 'multiple_per_week') | null
  timezone: string | null
  sends: {
    /** ISO weekday, weekly frequencies only */
    weekday?: number | null
    time: string
  }[]
  recipients: {
    email: string[]
    telegram: string[]
  }
}
export type AlertingScheduleOfOneAlertType2 = {
  project_id: number
  type: 'affiliates' | 'tm_infringements'
  mode: 'instant' | 'scheduled'
  /** required when mode=scheduled */
  frequency?: ('once_per_day' | 'multiple_per_day' | 'once_per_week' | 'multiple_per_week') | null
  /** required when mode=scheduled */
  timezone?: string | null
  /** mode=scheduled only */
  sends?: {
    /** ISO weekday, required for weekly frequencies */
    weekday?: number | null
    time: string
  }[]
  recipients?: {
    email?: string[]
    telegram?: string[]
  }
}
export type NotificationsCard = {
  project_id: number
  types?: {
    affiliates?: boolean
    tm_infringements?: boolean
  }
  weekly_report?: boolean
  recipients?: {
    channel?: 'email' | 'tg'
    value?: string
    /** Alert types for the recipient; a recipient with an empty list is removed from the project */
    subscriptions?: ('affiliates' | 'tm_infringements')[]
  }[]
}
export type ProfileForm = {
  username: string
  fio: string
  company?: string
}
export type ChangeEmailForm = {
  /** password for confirm */
  password?: string
  /** new email */
  new_email?: string
}
export type ChangePasswordForm = {
  /** old password */
  password: string
  /** new password */
  new_password: string
  /** repeat new password; not compared with new_password on the server */
  repeat_password?: string
}
export type Location = {
  /** Country ID */
  country_id?: number
  /** Array of languages. */
  languages?: {
    /** Language code */
    id?: string
    /** Language name */
    name?: string
  }[]
  /** Array of cities. If all cities needed, then pass one item with id=0. */
  cities?: {
    /** City ID */
    id?: number
  }[]
  /** Whether all cities of the country are selected. In responses reflects the saved state; on input all cities are requested via `cities` with one item id=0. */
  all_cities?: boolean
  /** Array of engine objects. */
  engines?: {
    /** Engine ID */
    id?: number
  }[]
}
export type TermSettings = {
  /** Country ID */
  country_id?: number
  /** Array of terms */
  terms?: string[]
  /** Language code */
  language_code?: string
}
export type ProjectForm = {
  /** `Step = first`. Project name. */
  project_name?: string
  /** `Step = first`. The brand name. */
  brand_name?: string
  /** `Step = first`. Array of brand name variants. */
  brand_variants?: string[]
  /** `Step = first`. Array of domains. */
  domains?: string[]
  /** `Step = first`. Array of devices. */
  devices?: {
    id?: number
    name?: string
  }[]
  /** `Step = first`. Array of search engines. */
  engines?: {
    id?: number
    name?: string
  }[]
  /** `Step = second`. Array of locations. */
  locations?: Location[]
  terms?: TermSettings
}
export type ProjectListRow = {
  id: number
  name: string
  status: string
  periodicity: string | null
  seo_periodicity: string | null
  keywords_count: number
  countries: string[]
  created_at: string
  updated_at: string
  is_demo: boolean
  has_active_affrules: boolean
  /** false → project has no active keywords, show `Missing keywords` label */
  has_keywords: boolean
}
export type ProjectInfoForm = {
  /** ID of the project, required for all scenarios. */
  id: number
  /** Name of the project, required in the update-info. */
  name: string | null
  /** Status of the project, required in the update-status. */
  status: ('active' | 'pause' | 'archive') | null
}
export type MainSettingsForm = {
  id: number
  name: string
  brand_name: string
  notifications: ProjectNotificationsCard
  brand_variants: string[]
  domains: string[]
  devices: {
    id?: number
    name?: string
  }[]
}
export type ProjectLocationRow = {
  project_id: number
  country_id: number
  country_name: string
  /** all cities of the country are selected; new cities of the country are added automatically */
  all_cities: boolean
  languages: {
    id?: string
    name?: string
  }[]
  engines: {
    id?: number
    name?: string
  }[]
  cities: {
    id?: number
    name?: string
  }[]
}
export type AvailableCountryRow = {
  id: number
  name: string
}
export type ProjectLocationDefaultsRow = {
  country_id: number
  country_name: string
  languages: {
    id: string
    name: string
  }[]
  engines: {
    id: number
    name: string
  }[]
  cities: {
    id: number
    name: string
  }[]
}
export type ProjectTermRow = {
  project_id: number
  country_id: number
  country_name: string
  language_code: string
  language_name: string
  terms: string[]
}
export type NotificationSendStat = {
  send: number
  error: number
}
export type ReferralLinkCreated = {
  id?: number
  code?: string
  is_active?: boolean
}
export type ReferralLinkStatus = {
  id?: number
  is_active?: boolean
}
export type ReferralClickResult = {
  cookie_id?: string
}
export type ReferralLinkListItem = {
  id: number
  code: string
  created_at: string
}
export type ReferralUserListItem = {
  id?: number
  username?: string
  email?: string
  last_visit?: string
  created_at?: string
  company_name?: string
  tariff_name?: string
  earned?: number
}
export type ReferralBalance = {
  total_earnings: number
  total_paid: number
  available: number
  pending: number
}
export type ReferralConversionStat = {
  conversion_rate?: number
  clicks?: number
  signups?: number
  paid_referrals?: number
}
export type ReferralStatByMonthItem = {
  month?: string
  clicks?: number
  signups?: number
  paid_referrals?: number
  earned?: number
}
export type ReferralPayoutItem = {
  id: number
  status: number
  amount: number
  requested_at: string
  processed_at: string | null
}
export type ReferralTerms = {
  revenue_share_percent: number
  cpa_reg_amount: number
  cpa_first_payment_amount: number
  full_first_payment_enabled: boolean
  currency: string
  currencySymbol: string
  is_default: boolean
}
export type ResearchKeywordsItem = {
  id: string
  project_id: number
  /** one of the keyword countries (order not guaranteed) */
  country_id: number | null
  keyword: string
  ads_count: string
  /** plain text of a collapsed list: names newline separated, empty lines must be skipped; with more than 2 names the last line is a 'More: N' label, not a name; empty string when none */
  country: string
  sites_count: number
  last_update: string
  first_link_at: string
  top_advertiser: string
  avk: number
}
export type ResearchChartSeries = {
  name?: string
  type?: string
  data?: number[][]
}
export type ResearchCompetitorsItem = {
  id: number
  project_id: number
  domain: string
  visibility: number
  ads_count: string
  top_keyword: string
  last_update: string
  first_link_at: string
}
export type ResearchCompetitorsColumnItem = {
  text: string
  title: string
  finish_domain: string
  first_found: string
  last_found: string
  /** comma separated */
  keywords: string
  visibility: number
}
export type ResearchKeywordsColumnAdvertisersItem = {
  finish_domain: string
  first_found: string
  last_found: string
  ads: string
  visibility: number
}
export type AdvertisingResearchItems = {
  title: string
  url: string
  has_brand: boolean
  keywords_count: number
  prev_keywords_count: number
  position: number
  previous_position: number | null
  top_keyword: string
  link_screen_url: string
  last_found: string
}
export type AdvertisingResearchKeywordItems = {
  keyword: string
  position: number
  previous_position: number | null
  last_found: string
  link_screen_url: string
  city: string
  country: string
  device: string
}
export type AdvertisingAffiliatesItems = {
  affiliate_id: string
  finish_domain: string
  redirects_count: number
  links_count: number
  redirects: string[]
  additionalRedirects?: string[][]
  page: string
  link_screen_url: string
  first_found: string
  last_found: string
  is_hidden: boolean | null
  publisher_id: number
}
export type SeoPositionItems = {
  hash: string
  keyword: string
  last_updated: string
  keyword_id: number
  page: string
  position: number
  previous_position: number | null
  search_screen_url: string
  last_found: string
}
export type SeoPositionChartItems = {
  name?: string
  type?: string
  data?: number[][]
}
export type BrandPresenceItems = {
  keyword: string
  keyword_id: number
  paid_count: number
  organic_count: number
  first_found: string
  last_found: string
  first_updated: string
  last_updated: string
}
export type BrandPresencePagesItems = {
  page: string
  position: number
  previous_position: number | null
  search_screen_url: string
  link_screen_url: string
  last_found: string
}
export type ResearchLiveItem = {
  title?: string
  description?: string
  position?: number
  label?: string
  isSeoLink?: boolean
  domain?: string
  link?: string
}
export type Wait = {
  wait: boolean
  dt?: string
  is_auth?: boolean
  timer: {
    /** milliseconds */
    duration?: number
    /** milliseconds */
    interval?: number
  }
  data: {
    requestType?: 'wait'
    leftAttempts?: number
  }
}
export type UserNotification = {
  id: number
  project_id?: number | null
  type:
    | 'onboarding_tutorial'
    | 'explore_demo_reports_block'
    | 'affiliate_tracking_setup'
    | 'affiliate_tracking_disabled'
    | 'first_affiliate_rule_setup'
    | 'affiliate_rule_sync_done'
    | 'notice'
    | 'alert'
    | 'recommendation'
  message?: string | null
  is_hidden: boolean
  active_at: string
  expired_at?: string | null
  /** type specific payload */
  data?: {
    [key: string]: any
  }
}
export type LoginUser = {
  id?: number
  username?: string
  email?: string
  last_visit?: string
  role?: string
  sub_role?: string
  language?: string
  front_menu_position?: 'sidebar' | 'top'
  telegram?: string
  fio?: string
  contact_method?: string | null
  contact_details?: string | null
  is_contact_confirmed?: boolean
  allow_decloak_auto?: boolean
  allow_decloak_live?: boolean
  allow_onboarding?: boolean
  is_master?: boolean
  is_virtual_mode?: boolean
  status?: string
  is_email_verified?: boolean
  notifications?: UserNotification[]
  allow_sending_from_linked_emails?: boolean
  company_id?: number
  /** TM Infringements feature is enabled for the company; otherwise /trademark/* and /tm-infringements/* return 404 */
  tm_infringements_enabled?: boolean
  plan?: {
    name?: string
    type?: string
    status?: string
    billing_period?: string
    started_at?: string
    ends_at?: string
  } | null
}
export type ArticleSettingsFilter = {
  id?: number
  type?: string
  name?: string
  url?: string
  sort_order?: number
}
export type FaqFilter = {
  id?: number
  question?: string
  answer?: string
  sort_order?: number
}
export type CustomerReviewFilter = {
  id?: number
  author?: string
  company?: string
  review?: string
  sort_order?: number
  logo_url?: string | null
}
export type Tariff = {
  id: number
  name: string
  type: string
  max_keywords: number
  max_users: number
  max_projects: number
  max_countries: number
  daily_checks_count: number
  duration: number
  paid_search_periodicity: string
  seo_periodicity: string
  /** numeric from PG, comes as string */
  price_monthly: string
  /** numeric from PG, comes as string */
  price_annually: string
  order: number
  is_current: boolean
  currency: string
  currency_symbol: string
}
export type TeamListFilter = {
  id: number
  username: string
  status: string
  email: string
  role: string
  sub_role: string
  project_ids: number[]
  projects: string[]
  last_visit: string
}
export type TeamAddUserForm = {
  name?: string
  email?: string
  sub_role?: string
  project_ids?: number[]
  auto_assign_new_projects?: boolean
  send_invitation?: boolean
}
export type TeamEditUserInfo = {
  id?: number
  name?: string
  email?: string
  sub_role?: string
  project_ids?: number[]
  auto_assign_new_projects?: boolean
}
export type TeamEditUserForm = {
  id: number
  name?: string
  sub_role?: string
  project_ids?: number[]
  auto_assign_new_projects?: boolean
}
export type TeamUserChangeStatusForm = {
  id: number
  status: 'active' | 'archived'
}
export type TeamSendInviteForm = {
  user_id: number
}
export type AdExampleWithTheTrademark = {
  title?: string
  text?: string
  /** landing page url */
  url?: string
  link_screen_url?: string | null
  /** SERP screenshot */
  search_screen_url?: string | null
  keyword?: string | null
  search_engine?: string
  ad_position?: number | null
  last_found?: string | null
  country?: string | null
}
export type TmInfringementRowDomainGeo = {
  infringement_id: number
  domain: string
  trademark?: {
    id?: number
    name?: string
  } | null
  country: {
    id?: number
    code?: string
    name?: string
  }
  latest_ad: AdExampleWithTheTrademark
  ads_count: number
  keywords_count: number
  engines: string[]
  first_found: string
  last_found: string
  complaint_status: 'to_submit' | 'submitted' | 'accepted' | 'rejected' | 'removed'
  top_status: 'to_submit' | 'in_progress' | 'removed'
  /** Google case id, empty until the service resolves it */
  case_id: string
  /** type of the Google verdict letter of the last case, null until the verdict, see /filter/tm-reply-type */
  reply_type?:
    | (
        | 'ad_not_found'
        | 'wrong_form'
        | 'multiple_trademarks'
        | 'trademark_not_found'
        | 'ad_complies_with_policy'
        | 'country_mismatch'
        | 'brand_as_keyword'
        | 'success_restriction'
        | 'different_policy_violation'
        | 'unknown'
      )
    | null
  has_repeat_history: boolean
  is_whitelisted: boolean
  /** the country is covered by a trademark registration */
  is_registered: boolean
  submit_enabled: boolean
  submitted_at?: string | null
}
export type TmInfringementsTabCounters = {
  to_submit?: number
  in_progress?: number
  submitted?: number
  accepted?: number
  rejected?: number
  removed?: number
}
export type DomainGeoStatus = {
  infringement_id: number
  country_id: number
  country: string
  country_code: string
  complaint_status: 'to_submit' | 'submitted' | 'accepted' | 'rejected' | 'removed'
  top_status: 'to_submit' | 'in_progress' | 'removed'
  has_repeat_history: boolean
}
export type SuccessReportTrend = {
  /** true for REPEAT rows that returned to To submit; other fields are empty then */
  hidden: boolean
  first_found?: string
  removed_at?: string | null
  points: {
    date?: string
    count?: number
  }[]
  markers: {
    type?: 'submitted' | 'accepted'
    date?: string
    /** Google case id, submitted markers only */
    case_id?: string | null
  }[]
}
export type SubmissionHistoryRecordOnePerCase = {
  /** internal case id, use it for /view-reply */
  id: number
  /** Google case id, appears after the service polling resolves it */
  case_id?: string | null
  task_id: string
  search_engine: string
  ad?: AdExampleWithTheTrademark | null
  trademark?: string | null
  last_found?: string
  complaint_status: 'to_submit' | 'submitted' | 'accepted' | 'rejected' | 'removed'
  /** type of the Google verdict letter, null until the verdict, see /filter/tm-reply-type */
  reply_type?:
    | (
        | 'ad_not_found'
        | 'wrong_form'
        | 'multiple_trademarks'
        | 'trademark_not_found'
        | 'ad_complies_with_policy'
        | 'country_mismatch'
        | 'brand_as_keyword'
        | 'success_restriction'
        | 'different_policy_violation'
        | 'unknown'
      )
    | null
  /** username of the user who submitted the complaint */
  actioned_by?: string | null
  submitted_at?: string
  /** time of the complaint status change by Google verdict, null until Google replies */
  updated_at?: string | null
  is_resubmit: boolean
  /** show the View reply button only when true */
  has_reply: boolean
  can_resubmit: boolean
}
export type GoogleRepliesForACase = {
  /** Google case id */
  case_id?: string | null
  complaint_status: 'to_submit' | 'submitted' | 'accepted' | 'rejected' | 'removed'
  /** type of the Google verdict letter, null until the verdict, see /filter/tm-reply-type */
  reply_type?:
    | (
        | 'ad_not_found'
        | 'wrong_form'
        | 'multiple_trademarks'
        | 'trademark_not_found'
        | 'ad_complies_with_policy'
        | 'country_mismatch'
        | 'brand_as_keyword'
        | 'success_restriction'
        | 'different_policy_violation'
        | 'unknown'
      )
    | null
  replies: {
    subject?: string | null
    body?: string
    received_at?: string | null
  }[]
}
export type PerCountrySubmitResultKeyedByInfringementId = {
  [key: string]: {
    status: 'created' | 'skipped' | 'failed'
    /** skipped/failed only: whitelisted, already {status}, no ad example, no new ad example since Google rejected the previous complaint, country not supported by the compliance service, compliance service unavailable, case save error */
    reason?: string
    /** created only */
    task_id?: string
    /** created only; internal case id */
    case_db_id?: number
    /** created only */
    is_resubmit?: boolean
  }
}
export type TrademarkListRow = {
  id: number
  name: string
  owner?: string | null
  status: 'active' | 'inactive'
  covered_country_ids: number[]
  registrations_count: number
  created_at?: string
}
export type Trademark = {
  id: number
  project_id: number
  name: string
  owner?: string | null
  owner_website?: string | null
  authorisation_letter_url?: string | null
  authorisation_letter_name?: string | null
  uploaded_at?: string | null
  status: 'active' | 'inactive'
  covered_country_ids: number[]
}
export type TrademarkCard = Trademark & {
  registrations: {
    id?: number
    country_id?: number
    country?: string | null
    registration_number?: string
  }[]
  /** unique domain × geo for the last 30 days */
  infringements_count: number
  created_at?: string
  updated_at?: string | null
}
export type RequestChangeTariffForm = {
  /** Tariff Id */
  tariff_id: number
  /** Payment periodicity */
  payment_periodicity: 'monthly' | 'annually'
  /** Stripe precheck */
  stripe_precheck?: boolean
}
export type CurrentTariffDetails = {
  tariff: {
    id?: number
    name?: string
    type?: string
    max_keywords?: number
    max_users?: number
    max_projects?: number
    max_countries?: number
    used_keywords_count?: number
    used_projects_count?: number
    duration?: number
    subscription_status?: string
    subscription_start_date?: string
    subscription_expiration_date?: string
    is_subscription_expired?: boolean
    payment_periodicity?: string
    price?: number
    currency?: string
    currency_symbol?: string
    payment_method?: string
    stripe_cancel_at?: string | null
  }
  /** project_id => details; empty JSON array when the company has no keywords */
  project_details: {
    [key: string]: {
      project_name?: string
      keywords_count?: number
      /** `Country, Language` => keywords count */
      locations?: {
        [key: string]: number
      }
    }
  }
  /** `Country, Language` => keywords count; empty JSON array when the company has no keywords */
  location_details: {
    [key: string]: number
  }
}
export type SendFeedbackForm = {
  /** Feedback message */
  message?: string
}
export type ConfirmContactForm = {
  /** Contact method */
  contact_method?: 'telegram' | 'email' | 'linkedin' | 'whatsapp' | 'skype'
  /** Contact details */
  contact_details?: string
}
export const {
  useGetAdOverviewAdsQuery,
  useGetAdOverviewAffiliatesQuery,
  useGetAdOverviewAffiliatesAdsQuery,
  useGetAdOverviewPublisherQuery,
  usePostAdOverviewPublisherMutation,
  usePostAdOverviewHideAffiliateMutation,
  useGetAdminVirtualUsersQuery,
  usePostAdminVirtualLoginMutation,
  useGetAdvertiserReportsAllAdvertisersQuery,
  useGetAdvertiserReportsOrganicQuery,
  usePostAdvertiserReportsSiteSettingsMutation,
  usePostAdvertiserReportsDecloakSettingsMutation,
  useGetAffiliateGetQuery,
  useGetAffiliateLastAdQuery,
  usePostAffiliateHideMutation,
  usePostAffiliateUpdateMutation,
  usePostAffiliateCreateNetworkMutation,
  useGetAffiliateRuleListQuery,
  usePostAffiliateRuleCreateMutation,
  usePostAffiliateRuleUpdateMutation,
  usePostAffiliateRuleRunSyncMutation,
  usePostAffiliateRuleDeleteAffiliatesMutation,
  usePostAffiliateRuleCreateCustomZoneMutation,
  useGetComplianceNonCompliantAffiliatesQuery,
  usePostComplianceSendAbuseMailMutation,
  useGetComplianceGetEmailListQuery,
  useGetComplianceLastSendEmailQuery,
  useGetDecloakFilterQuery,
  useGetDecloakCompareScreenshotsQuery,
  useGetDecloakCompareHtmlQuery,
  useGetDecloakCompareLinksQuery,
  useGetDecloakAdQuery,
  useGetDecloakLiveQuery,
  useGetDecloakCountryQuery,
  useGetDomainTagListQuery,
  usePostDomainTagCreateMutation,
  usePostDomainTagUpdateMutation,
  usePostDomainTagDeleteMutation,
  usePostDomainTagAssignMutation,
  usePostDomainTagUnassignMutation,
  useGetDomainTagByDomainQuery,
  useGetExportReportsAllAdvertisersQuery,
  useGetExportReportsDomainAdvertisersQuery,
  useGetExportReportsAffiliatesQuery,
  useGetExportReportsAffiliateLastAdQuery,
  useGetExportReportsAffiliateAdsQuery,
  useGetExportReportsNonCompliantAffiliatesQuery,
  useGetFeaturesDecloakQuery,
  useGetFilterProjectsQuery,
  useGetFilterCountryQuery,
  useGetFilterAdvertiserDomainsQuery,
  useGetFilterAdvertiserLandingQuery,
  useGetFilterCityQuery,
  useGetFilterEngineQuery,
  useGetFilterEngineLiveSearchQuery,
  useGetFilterBrowserQuery,
  useGetFilterDevicesQuery,
  useGetFilterDeviceTypesQuery,
  useGetFilterAdsTypesQuery,
  useGetFilterKeywordsQuery,
  useGetFilterAffiliatesQuery,
  useGetFilterPolicyQuery,
  useGetFilterOwnDomainsQuery,
  useGetFilterAffiliateStatusQuery,
  useGetFilterNetworkQuery,
  useGetFilterProjectStatusQuery,
  useGetFilterBrowserLanguageQuery,
  useGetFilterCompanyQuery,
  useGetFilterCompanyRoleQuery,
  useGetFilterAssistanceRequestQuery,
  useGetFilterSubRolesQuery,
  useGetFilterDomainZonesQuery,
  useGetFilterContactMethodQuery,
  useGetFilterPayoutStatusQuery,
  useGetFilterAdvertiserNamesQuery,
  useGetFilterTrademarkQuery,
  useGetFilterCaseIdQuery,
  useGetFilterTmReplyTypeQuery,
  useGetFilterTmInfringementDomainsQuery,
  useGetFilterAlertTypeQuery,
  useGetFilterNotificationDeliveryModeQuery,
  useGetFilterNotificationFrequencyQuery,
  useGetFilterNotificationChannelQuery,
  useGetFilterWeekdayQuery,
  useGetFilterTimezoneQuery,
  useGetLanguageComplianceLastCheckQuery,
  useGetLanguageComplianceInProgressQuery,
  useGetLanguageComplianceHistoryQuery,
  useGetLanguageComplianceCounterQuery,
  useGetLanguageComplianceHistoryDetailQuery,
  useGetLanguageComplianceReportQuery,
  useGetLanguageComplianceExportQuery,
  useGetLanguageComplianceFilterProjectQuery,
  useGetLanguageComplianceFilterCountryQuery,
  useGetLanguageComplianceFilterPageQuery,
  useGetLanguageComplianceFilterAffiliateQuery,
  useGetLanguageComplianceFilterWordQuery,
  usePostLanguageComplianceUpdateStateMutation,
  usePostN8NSendMessageMutation,
  useGetNotificationStateQuery,
  useGetNotificationScheduleQuery,
  usePostNotificationSaveScheduleMutation,
  usePostNotificationSaveCardMutation,
  useGetProfileInfoQuery,
  usePostProfileInfoMutation,
  usePostProfileChangeEmailMutation,
  usePostProfileChangePasswordMutation,
  usePostProfileMenuPositionMutation,
  usePostProjectCreateMutation,
  useGetProjectListQuery,
  usePostProjectUpdateStatusMutation,
  useGetProjectInfoQuery,
  usePostProjectUpdateInfoMutation,
  useGetProjectMainSettingsQuery,
  usePostProjectUpdateMainSettingsMutation,
  useGetProjectLocationsQuery,
  usePostProjectUpdateLocationsMutation,
  useGetProjectAvailableCountriesQuery,
  useGetProjectLocationsDefaultSettingsQuery,
  useGetProjectTermsQuery,
  usePostProjectUpdateTermsMutation,
  usePostProjectSendWeeklyReportTelegramMutation,
  usePostProjectSendWeeklyReportEmailMutation,
  usePostProjectSendAlertTelegramMutation,
  usePostProjectSendAlertEmailMutation,
  usePostProjectSendTmAlertTelegramMutation,
  usePostProjectSendTmAlertEmailMutation,
  useGetProjectDownloadReportQuery,
  useGetProjectBrandDomainsQuery,
  usePostProjectDeleteDemoProjectMutation,
  usePostReferralCreateLinkMutation,
  usePostReferralDeleteLinkMutation,
  usePostReferralClickMutation,
  useGetReferralLinkListQuery,
  useGetReferralUserListQuery,
  useGetReferralBalanceQuery,
  useGetReferralConversionStatQuery,
  useGetReferralStatByMonthQuery,
  usePostReferralPayoutRequestMutation,
  useGetReferralPayoutsListQuery,
  useGetReferralTermsQuery,
  useGetResearchKeywordsQuery,
  useGetResearchKeywordsDateRangeQuery,
  usePostResearchKeywordsChartMutation,
  useGetResearchCompetitorsQuery,
  useGetResearchCompetitorsDateRangeQuery,
  usePostResearchCompetitorsChartMutation,
  useGetResearchCompetitorsColumnQuery,
  useGetResearchKeywordsColumnAdvertisersQuery,
  useGetResearchAdvertisingQuery,
  useGetResearchAdvertisingKeywordQuery,
  useGetResearchAdvertisingAffiliatesQuery,
  useGetResearchSeoPositionQuery,
  usePostResearchSeoPositionChartMutation,
  useGetResearchBrandPresenceQuery,
  useGetResearchBrandPresencePagesQuery,
  useGetResearchLiveQuery,
  useGetResearchLiveRedirectsQuery,
  useGetResearchLiveDecloakAutoQuery,
  usePostSiteLoginMutation,
  usePostSiteSignupMutation,
  useGetSiteCurrentuserQuery,
  usePostSiteContactMutation,
  usePostSiteRequestDemoMutation,
  usePostSiteLogoutMutation,
  usePostSiteRequestPasswordResetMutation,
  usePostSiteResetPasswordMutation,
  usePostSiteVerifyEmailMutation,
  usePostSiteGoogleOauthMutation,
  useGetSiteGoogleReportOauthUrlQuery,
  usePostSiteGoogleReportOauthSaveMutation,
  usePostSiteGoogleReportOauthDeleteTokenMutation,
  usePostSiteSendVerificationEmailMutation,
  usePostSiteHideNotificationMutation,
  useGetSiteArticleSettingsQuery,
  useGetSiteFaqQuery,
  useGetSiteCustomerReviewsQuery,
  useGetTariffListQuery,
  useGetTeamManagementListQuery,
  usePostTeamManagementAddUserMutation,
  useGetTeamManagementEditUserQuery,
  usePostTeamManagementEditUserMutation,
  usePostTeamManagementUserChangeStatusMutation,
  usePostTeamManagementSendInviteMutation,
  useGetTmInfringementsListQuery,
  useGetTmInfringementsCounterQuery,
  useGetTmInfringementsDomainSummaryQuery,
  useGetTmInfringementsSuccessReportQuery,
  useGetTmInfringementsHistoryQuery,
  useGetTmInfringementsViewReplyQuery,
  usePostTmInfringementsWhitelistMutation,
  usePostTmInfringementsSubmitMutation,
  usePostTmInfringementsResubmitMutation,
  useGetTrademarkListQuery,
  useGetTrademarkCardQuery,
  usePostTrademarkCreateMutation,
  usePostTrademarkUpdateMutation,
  usePostTrademarkUploadLetterMutation,
  usePostTrademarkRegistrationAddMutation,
  usePostTrademarkRegistrationUpdateMutation,
  usePostTrademarkRegistrationDeleteMutation,
  usePostTrademarkArchiveMutation,
  usePostTrademarkActivateMutation,
  usePostUserRequestChangeTariffMutation,
  useGetUserCurrentTariffDetailsQuery,
  usePostUserSendFeedbackMutation,
  usePostUserGetStripePortalLinkMutation,
  usePostUserRequestChangeReferralTermsMutation,
  usePostUserConfirmContactMutation,
} = injectedRtkApi
